document.addEventListener("DOMContentLoaded", () => { 

  /* =========================
   * 1. INPUT EN HEADER
   * ========================= */
  const root = document.getElementById("external-search-root");
  if (!root) return;

  root.innerHTML = `
    <input
      id="external-search-input"
      type="text"
      placeholder="Busca entre más de 400.000 productos..."
      autocomplete="off"
      style="
        width:100%;
        padding:14px 16px;
        font-size:16px;
        border:1px solid #9ca3af;
        border-radius:8px;
        box-sizing:border-box;
        background:#fff;
        outline:none;
        box-shadow:inset 0 0 0 1px rgba(17,24,39,.03);
      "
    />
  `;

  const input = document.getElementById("external-search-input");

  function getMobileInput() {
    return document.getElementById("external-search-input-mobile");
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function getCurrentRate() {
    return String(window.CUSTOMER_RATE || "").replace(/\D/g, "");
  }

  function shouldUseDesktopQtySelector() {
    const rate = getCurrentRate();
    return !isMobile() && (rate === "1" || rate === "2");
  }

  function shouldShowProductIdentifiers() {
    const rate = getCurrentRate();
    return rate === "1" || rate === "2";
  }

  function shouldShowViewInsteadOfAdd(product) {
    return Number(product?.stock ?? 0) === 0 && Number(product?.stock_provider ?? 0) === 0;
  }

  function getAddToCartLabel() {
    return "Añadir";
  }

  function updateAddToCartButtonsText() {
    const buttons = document.querySelectorAll("#external-search-modal .add-to-cart:not(.loading)");
    buttons.forEach(btn => {
      btn.textContent = btn.dataset.action === "view" ? "Ver" : getAddToCartLabel();
    });
  }

  /* =========================
   * 1.1 ÚLTIMAS BÚSQUEDAS
   * ========================= */
  const RECENT_SEARCHES_KEY = "external_search_recent_searches_v1";
  const MAX_RECENT_SEARCHES = 20;
  let recentSearchSaveTimer = null;

  function escapeHtml(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function escapeHtmlAllowEm(str = "") {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/&lt;(\/?em)&gt;/gi, "<$1>");
  }

  function getRecentSearches() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function saveRecentSearch(term) {
    const q = String(term || "").trim();
    if (q.length < 2) return;

    const list = getRecentSearches().filter(item => item.toLowerCase() !== q.toLowerCase());
    list.unshift(q);

    localStorage.setItem(
      RECENT_SEARCHES_KEY,
      JSON.stringify(list.slice(0, MAX_RECENT_SEARCHES))
    );
  }

  function removeRecentSearch(term) {
    const q = String(term || "").trim().toLowerCase();
    const list = getRecentSearches().filter(item => item.toLowerCase() !== q);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(list));
  }

  function clearRecentSearches() {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  }

  /* =========================
   * 2. MODAL OVERLAY
   * ========================= */
  const modal = document.createElement("div");
  modal.id = "external-search-modal";
  modal.style.display = "none";

  modal.innerHTML = `
    <style>
      .mobile-search-header,
      .external-search-input-mobile,
      .mobile-filters-toggle {
        display: none;
      }

      body.search-open {
        overflow: hidden;
      }

      #external-search-modal {
        position: fixed;
        left: 0;
        right: 0;
        background: #fff;
        z-index: 9999;
        border-top: 1px solid #e5e5e5;
        height: calc(100vh - var(--top, 0px));
      }

      #desktop-search-close{
        display:none;
      }

      @media (min-width: 769px){
        #desktop-search-close{
          display:flex;
          align-items:center;
          justify-content:center;
          position:absolute;
          top:20px;
          right:24px;
          width:40px;
          height:40px;
          border:1px solid rgba(17, 24, 39, .10);
          background:rgba(255,255,255,.88);
          color:#4b5563;
          font-size:24px;
          font-weight:600;
          line-height:1;
          cursor:pointer;
          z-index:10020;
          padding:0;
          border-radius:10px;
          box-shadow:0 4px 14px rgba(0,0,0,.06);
          transition: background .18s ease, color .18s ease, box-shadow .18s ease, transform .18s ease;
        }

        #desktop-search-close:hover{
          background:#fff;
          color:#111827;
          box-shadow:0 8px 22px rgba(0,0,0,.10);
          transform: translateY(-1px);
        }
      }

      .layout{
        width: min(90vw, 2000px);
        margin: auto;
        display: grid;
        grid-template-columns: 260px 1fr;
        gap: 32px;
        padding: 24px;
        height: 100%;
        box-sizing: border-box;
      }

      .filters {
        overflow-y: auto;
        padding-right: 8px;
      }

      .filters h4 {
        font-size: 14px;
        margin: 20px 0 8px;
      }

      .filters label {
        display: block;
        font-size: 13px;
        cursor: pointer;
        margin-bottom: 6px;
      }

      .results-wrap {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
        min-width: 0;
      }

      .results-scroll {
        overflow-y: auto;
        padding-right: 8px;
        min-height: 0;
        flex: 1;
        min-width: 0;
      }

      .results {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 18px;
        margin-top: 12px;
        min-width: 0;
      }

      .filters label input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        width: 20px;
        height: 20px;
        margin: 0;
      }

      .filters label {
        position: relative;
        display: block;
        cursor: pointer;
        padding-left: 32px;
        margin-bottom: 12px;
        user-select: none;
        font-size: 14px;
        line-height: 18px;
        margin-left: 4px;
      }

      .filters label::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-color: #fff;
        border: 3px solid #fff;
        border-radius: 4px;
        box-shadow: 0 0 0 2px #292B26;
        transition: background-color 0.2s ease;
      }

      .filters label:hover::before {
        background-color: #cce4ff;
      }

      .filters label:has(input[type="checkbox"]:checked)::before {
        background-color: #292B26;
        border-color: #fff;
        box-shadow: 0 0 0 2px #292B26;
      }

      .card {
        position: relative;
        border: 1px solid #eaeaea;
        padding: 14px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        height: 100%;
        min-width: 0;
        overflow: hidden;
        box-sizing: border-box;
      }

      .card-content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        min-width: 0;
      }

      .product-name {
        text-align: center;
        font-size: 17px;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        min-height: calc(1.3em * 3);
        max-height: calc(1.3em * 3);
        margin-bottom: 8px;
      }

      .product-ids{
        text-align: center;
        font-size: 12px;
        color: #666;
        line-height: 1.2;
        margin-bottom: 8px;
      }

      .card-meta {
        margin-top: auto;
        text-align: center;
      }

      .price {
        font-weight: 700;
        font-size: 19px;
        margin-bottom: 4px;
      }

      .delivery-text {
        font-size: 14px;
        color: green;
        min-height: 16px;
        margin-bottom: 12px;
      }

      .img {
        aspect-ratio: 1 / 1;
        margin: -8px -8px 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border-radius: 10px 10px 0 0;
      }

      .img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        display: block;
      }

      /* ===== corazón wishlist SOLO PC ===== */
      .search-wishlist-btn{
        position:absolute;
        top:8px;
        right:8px;
        z-index:3;
        width:34px;
        height:34px;
        border:1px solid rgba(255,255,255,.10);
        border-radius:11px;
        background:rgba(255,255,255,.10);
        backdrop-filter:blur(2px);
        -webkit-backdrop-filter:blur(2px);
        box-shadow:0 4px 10px rgba(17,24,39,.04);
        color:#18212f;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        padding:0;
        transition:
          transform .18s ease,
          box-shadow .18s ease,
          background .18s ease,
          border-color .18s ease,
          color .18s ease;
      }

      .search-wishlist-btn:hover{
        background:rgba(255,255,255,.16);
        border-color:rgba(255,255,255,.16);
        box-shadow:0 8px 16px rgba(17,24,39,.07);
        transform:translateY(-1px);
      }

      .search-wishlist-btn:focus-visible{
        outline:none;
        box-shadow:
          0 0 0 3px rgba(24,33,47,.08),
          0 8px 16px rgba(17,24,39,.07);
      }

      .search-wishlist-btn svg{
        width:18px;
        height:18px;
        display:block;
      }

      .search-wishlist-btn__icon{
        width:18px;
        height:18px;
        display:flex;
        align-items:center;
        justify-content:center;
        color:#111827;
      }

      .search-wishlist-btn__icon svg{
        width:18px;
        height:18px;
        display:block;
      }

      .search-wishlist-btn.is-active{
        background:rgba(255,255,255,.18);
        border-color:rgba(255,255,255,.18);
        color:#111827;
      }

      .search-wishlist-btn.is-active .search-wishlist-btn__icon{
        color:#111827;
      }

      .search-wishlist-btn.is-active .search-wishlist-btn__icon path{
        fill:#111827;
        stroke:#111827;
      }

      .search-wishlist-btn.is-active svg path{
        fill:#111827;
        stroke:#111827;
      }

      .search-wishlist-btn.is-loading{
        opacity:.7;
        pointer-events:none;
      }

      .add-row{
        display:flex;
        align-items:stretch;
        justify-content:flex-start;
        gap:2px;
        margin-top:auto;
        width:100%;
        min-width:0;
      }

      .qty-box{
        display:flex;
        align-items:stretch;
        flex:0 0 64px;
        width:64px;
        min-width:64px;
        max-width:64px;
        height:40px;
      }

      .qty-input{
        width:40px;
        min-width:40px;
        max-width:40px;
        border:1px solid #d1d5db;
        border-right:0;
        border-radius:8px 0 0 8px;
        text-align:center;
        font-size:15px;
        font-weight:700;
        color:#111;
        background:#fff;
        outline:none;
        padding:0 2px;
        box-sizing:border-box;
        -moz-appearance:textfield;
      }

      .qty-input::-webkit-outer-spin-button,
      .qty-input::-webkit-inner-spin-button{
        -webkit-appearance:none;
        margin:0;
      }

      .qty-buttons{
        display:flex;
        flex-direction:column;
        width:24px;
        min-width:24px;
        max-width:24px;
      }

      .qty-btn{
        flex:1 1 50%;
        border:1px solid #d1d5db;
        background:#fff;
        color:#292B26;
        font-size:15px;
        font-weight:700;
        line-height:1;
        cursor:pointer;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:0;
        box-sizing:border-box;
      }

      .qty-btn:hover{
        background:#f3f4f6;
      }

      .qty-plus{
        border-radius:0 8px 0 0;
      }

      .qty-minus{
        border-top:0;
        border-radius:0 0 8px 0;
      }

      .add-to-cart {
        flex:1 1 auto;
        min-width:0;
        width:auto;
        max-width:100%;
        height:40px;
        padding:0 14px;
        border-radius:8px;
        border:none;
        background:#292B26;
        color:#fff;
        font-size:15px;
        font-weight:700;
        cursor:pointer;
        margin-top:auto;
        box-sizing:border-box;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
      }

      .add-to-cart.loading {
        opacity: .6;
        pointer-events: none;
      }

      .mobile-search-header {
        display: none;
        gap: 8px;
        align-items: center;
      }

      @media (max-width: 768px) {
        .mobile-search-header {
          display: flex;
        }
      }

      @media (max-width: 768px) {
        #external-search-modal {
          top: 0 !important;
          height: 100vh !important;
          display: flex;
          flex-direction: column;
        }

        .product-ids{
          display: none;
        }

        .mobile-search-header {
          position: sticky;
          top: 0;
          background: #fff;
          padding: 10px;
          border-bottom: 1px solid #e5e5e5;
          z-index: 10;
        }

        .layout {
          width: 100%;
          max-width: none;
          margin: 0;
          grid-template-columns: 1fr;
          padding: 8px;
          flex: 1;
          overflow: hidden;
        }

        .filters {
          display: none;
          padding: 12px 0;
        }

        .filters.open {
          display: block;
        }

        .mobile-filters-toggle {
          display: block;
          width: 100%;
          margin: 8px 0;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ddd;
          background: #f7f7f7;
          font-size: 14px;
          cursor: pointer;
        }

        .results {
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
        }

        .img {
          width: 100%;
          height: auto;
          aspect-ratio: 1 / 1;
        }

        .qty-box{
          display:none;
        }

        .search-wishlist-btn{
          display:none !important;
        }

        .add-row{
          display:block;
          width:100%;
        }

        .add-to-cart{
          width:100%;
          min-width:0;
          max-width:100%;
          border-radius:8px;
          font-size:16px;
        }
      }

      .sort-bar {
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 10px 0 6px;
        padding: 8px 12px;
        background: transparent;
        border: 0;
        border-radius: 8px;
      }

      .sort-label {
        font-size: 13px;
        font-weight: 600;
        color: #444;
        margin-right: 6px;
      }

      .sort-bar select {
        font-size: 13px;
        padding: 6px 10px;
        border-radius: 6px;
        border: 1px solid #d1d5db;
        background: #fff;
        cursor: pointer;
      }

      .sort-bar select:focus {
        outline: none;
        border-color: #292B26;
      }

      .facet{
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        background: #fff;
        margin-bottom: 12px;
        overflow: hidden;
      }

      .facet-header{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 14px;
        background: #fff;
        border: 0;
        cursor: pointer;
      }

      .facet-title{
        font-size: 15px;
        font-weight: 700;
        color: #111;
      }

      .facet-chevron{
        font-size: 18px;
        line-height: 1;
        transform: rotate(0deg);
        transition: transform .15s ease;
      }

      .facet.collapsed .facet-chevron{
        transform: rotate(-90deg);
      }

      .facet-body{
        padding: 0 14px 12px;
      }

      .facet.collapsed .facet-body{
        display: none;
      }

      .facet-list{
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .filters label.facet-item{
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        padding-left: 32px;
        user-select: none;
        cursor: pointer;
        font-size: 14px;
        line-height: 18px;
        margin: 0;
      }

      .filters label.facet-item::before{
        content:'';
        position:absolute;
        top:50%;
        left:0;
        transform: translateY(-50%);
        width:20px;
        height:20px;
        background:#fff;
        border: 3px solid #fff;
        border-radius: 6px;
        box-shadow: 0 0 0 2px #292B26;
        transition: background-color .2s ease;
      }

      .filters label.facet-item:hover::before{
        background:#cce4ff;
      }

      .filters label.facet-item:has(input[type="checkbox"]:checked)::before{
        background:#292B26;
        border-color:#fff;
      }

      .facet-name{
        flex: 1;
        color: #111;
      }

      .facet-count{
        color: #6b7280;
        font-size: 13px;
      }

      .sort-bar--doo{
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 12px;
      }

      .sort-left{
        display:flex;
        align-items:center;
        gap: 10px;
      }

      .sort-right{
        display:flex;
        align-items:center;
        gap: 10px;
        margin-left: auto;
      }

      .sort-right select{
        min-width: 240px;
      }

      @media (max-width: 768px){
        .sort-right{
          width: 100%;
          justify-content: space-between;
        }
        .sort-right select{
          width: 100%;
          min-width: 0;
        }
      }

      .mobile-actions{ display:none; }
      .results-count{ margin: 6px 0 10px; }

      @media (max-width: 768px){
        .sort-bar.sort-bar--doo{ display:none; }

        .mobile-actions{
          display:grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          margin: 10px 0 8px;
        }

        .mobile-actions button{
          width:100%;
          padding: 12px 10px;
          border-radius: 10px;
          border: 1px solid #d1d5db;
          background:#fff;
          font-weight:700;
          font-size: 15px;
        }
      }

      .drawer{
        position: fixed;
        inset: 0;
        background: #fff;
        z-index: 10050;
        display: none;
        flex-direction: column;
      }

      .drawer.open{ display:flex; }

      .drawer-header{
        display:flex;
        align-items:center;
        justify-content: space-between;
        padding: 14px 12px;
        border-bottom: 1px solid #e5e5e5;
      }

      .drawer-title{
        font-weight: 800;
        font-size: 16px;
      }

      .drawer-close{
        width:44px;
        height:44px;
        border:0;
        background: none;
        font-size: 28px;
        line-height: 1;
        cursor: pointer;
      }

      .drawer-clear{
        width:64px;
        height:44px;
        border:0;
        background:none;
        font-size: 14px;
        cursor: pointer;
        color:#444;
      }

      .drawer-body{
        flex: 1;
        overflow: auto;
        padding: 12px;
      }

      .drawer-footer{
        position: sticky;
        bottom: 0;
        padding: 12px;
        border-top: 1px solid #e5e5e5;
        background: #fff;
      }

      .drawer-apply{
        width: 100%;
        padding: 14px 12px;
        border-radius: 10px;
        border: 0;
        background: #292B26;
        color: #fff;
        font-weight: 800;
        font-size: 16px;
        cursor: pointer;
      }

      .radio-row{
        display:flex;
        align-items:center;
        gap: 10px;
        padding: 14px 6px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 15px;
      }

      .radio-row input{ transform: scale(1.15); }

      @media (max-width:768px){
        #external-search-modal:not(.has-results) .mobile-actions,
        #external-search-modal:not(.has-results) .results-count,
        #external-search-modal:not(.has-results) #results-scroll{
          display: none !important;
        }
      }

      @media (min-width: 769px){
        .results-wrap{
          display: grid;
          grid-template-columns: 1fr auto;
          grid-template-rows: auto 1fr;
          column-gap: 16px;
          row-gap: 8px;
          align-items: start;
          height: 100%;
          overflow: hidden;
        }

        .results-count{
          grid-column: 1;
          grid-row: 1;
          margin: 0;
        }

        .sort-bar.sort-bar--doo{
          grid-column: 2;
          grid-row: 1;
          margin: 0;
          padding: 0;
          justify-content: flex-end;
          align-self: start;
        }

        #results-scroll{
          grid-column: 1 / -1;
          grid-row: 2;
          min-height: 0;
          height: 100%;
        }

        .results{
          margin-top: 0;
        }
      }

      .facet-tools{
        display:flex;
        flex-direction:column;
        gap:10px;
        margin: 10px 0 10px;
      }

      .facet-search{
        width:100%;
        padding:10px 12px;
        font-size:14px;
        border:1px solid #d1d5db;
        border-radius:8px;
        background:#fff;
        box-sizing:border-box;
      }

      .facet-search:focus{
        outline:none;
        border-color:#292B26;
      }

      .facet-more{
        display:inline-flex;
        align-items:center;
        justify-content:center;
        padding:10px 12px;
        border:1px solid #d1d5db;
        border-radius:8px;
        background:#fff;
        font-size:14px;
        font-weight:600;
        cursor:pointer;
        width: 100%;
      }

      .facet-more:hover{
        background:#f7f7f7;
      }

      .desktop-recent-searches{
        display:none;
      }

      .recent-searches-card{
        width:100%;
      }

      .recent-searches-inline{
        display:flex;
        align-items:flex-start;
        gap:8px;
        width:100%;
      }

      .recent-searches-title{
        font-size:12px;
        font-weight:700;
        color:#111;
        white-space:nowrap;
        flex:0 0 auto;
        margin:6px 0 0 0;
        line-height:1;
      }

      .recent-searches-flow{
        display:flex;
        flex-wrap:wrap;
        align-items:center;
        gap:8px;
        flex:1 1 auto;
        min-width:0;
      }

      #desktop-recent-searches-list{
        display:contents;
      }

      #desktop-recent-clear{
        border:0;
        background:none;
        color:#1a579a;
        font-size:13px;
        font-weight:500;
        cursor:pointer;
        padding:0;
        white-space:nowrap;
      }

      .recent-search-chip{
        display:inline-flex;
        align-items:center;
        gap:4px;
        border:1px solid #c7cdd4;
        border-radius:999px;
        background:#fff;
        padding:2px 8px 2px 10px;
        min-height:28px;
        max-width:100%;
      }

      .recent-search-chip-term{
        border:0;
        background:none;
        cursor:pointer;
        font-size:12px;
        line-height:1;
        color:#444;
        padding:0;
        white-space:nowrap;
      }

      .recent-search-chip-remove{
        border:0;
        background:none;
        cursor:pointer;
        font-size:16px;
        line-height:1;
        color:#666;
        padding:0;
      }

      .recent-search-empty{
        color:#777;
        font-size:14px;
      }

      @media (min-width: 769px){
        #external-search-modal.show-recent{
          position: fixed !important;
          left: 0 !important;
          right: 0 !important;
          background: #e9ecef !important;
          border-top: 1px solid #dfe3e8 !important;
          box-shadow: 0 10px 18px rgba(0,0,0,.05);
          overflow-y: auto !important;
          overflow-x: hidden !important;
        }

        #external-search-modal.show-recent .layout{
          width: min(90vw, 2000px) !important;
          margin: 0 auto !important;
          display: block !important;
          padding: 20px 24px !important;
          height: auto !important;
        }

        #external-search-modal.show-recent .filters{
          display: none !important;
        }

        #external-search-modal.show-recent .results-wrap{
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow: visible !important;
          height: auto !important;
          min-height: 0 !important;
          background: transparent !important;
          border: 0 !important;
          border-radius: 0 !important;
          padding: 0 !important;
          box-shadow: none !important;
        }

        #external-search-modal.show-recent .mobile-actions,
        #external-search-modal.show-recent .results-count,
        #external-search-modal.show-recent .sort-bar,
        #external-search-modal.show-recent #results-scroll{
          display:none !important;
        }

        #external-search-modal.show-recent .desktop-recent-searches{
          display:block !important;
          width:100% !important;
          max-width:100% !important;
          padding-right:64px !important;
          box-sizing:border-box !important;
        }
      }

      @media (max-width: 768px){
        #external-search-modal.show-recent{
          background: transparent !important;
          border-top: 0 !important;
          height: 100vh !important;
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch;
        }

        #external-search-modal.show-recent .layout{
          display:block !important;
          width:100% !important;
          padding: 8px 10px 12px !important;
          height:auto !important;
          overflow: visible !important;
        }

        #external-search-modal.show-recent .filters{
          display:none !important;
        }

        #external-search-modal.show-recent .results-wrap{
          display:block !important;
          width:100% !important;
          max-width:100% !important;
          overflow:visible !important;
          height:auto !important;
          background:#fff;
          border:1px solid #e5e7eb;
          border-radius:14px;
          padding:14px 12px;
          box-shadow:0 8px 24px rgba(0,0,0,.08);
        }

        #external-search-modal.show-recent .mobile-actions,
        #external-search-modal.show-recent .results-count,
        #external-search-modal.show-recent .sort-bar,
        #external-search-modal.show-recent #results-scroll{
          display:none !important;
        }

        #external-search-modal.show-recent .desktop-recent-searches{
          display:block !important;
        }

        .recent-searches-inline{
          flex-direction:column;
          align-items:stretch;
          gap:10px;
        }

        .recent-searches-title{
          margin:0;
          white-space:normal;
        }

        .recent-searches-flow{
          gap:8px;
        }

        #desktop-recent-clear{
          align-self:flex-start;
        }

        .recent-search-chip{
          min-height:32px;
        }

        .recent-search-chip-term{
          font-size:13px;
        }
      }

      /* ===== modal wishlist buscador ===== */
      .search-wishlist-modal[hidden] {
        display:none !important;
      }

      .search-wishlist-modal{
        position:fixed;
        inset:0;
        z-index:10060;
      }

      .search-wishlist-modal__backdrop{
        position:absolute;
        inset:0;
        background:rgba(15,23,42,.45);
      }

      .search-wishlist-modal__dialog{
        position:relative;
        z-index:2;
        width:min(92vw, 520px);
        max-height:85vh;
        overflow:auto;
        margin:6vh auto 0;
        background:#fff;
        border-radius:20px;
        box-shadow:0 24px 64px rgba(15,23,42,.24);
        border:1px solid #edf0f5;
      }

      .search-wishlist-modal__header{
        display:flex;
        align-items:flex-start;
        justify-content:space-between;
        gap:16px;
        padding:18px 18px 14px;
        border-bottom:1px solid #eef1f5;
      }

      .search-wishlist-modal__title{
        margin:0;
        font-size:19px;
        line-height:1.2;
        color:#18212f;
      }

      .search-wishlist-modal__subtitle{
        margin:6px 0 0;
        font-size:13px;
        line-height:1.45;
        color:#6b7280;
      }

      .search-wishlist-modal__close{
        width:36px;
        height:36px;
        min-width:36px;
        border:0;
        border-radius:10px;
        background:#f6f7fb;
        color:#18212f;
        font-size:22px;
        line-height:1;
        cursor:pointer;
      }

      .search-wishlist-modal__body{
        padding:16px 18px;
        display:flex;
        flex-direction:column;
        gap:10px;
      }

      .search-wishlist-list-option{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:14px;
        padding:14px 15px;
        border:1px solid #e6eaf1;
        border-radius:14px;
        background:#fff;
        cursor:pointer;
        transition:border-color .18s ease, transform .18s ease, box-shadow .18s ease, background .18s ease;
        text-align:left;
      }

      .search-wishlist-list-option:hover{
        border-color:#cfd7e3;
        transform:translateY(-1px);
        box-shadow:0 12px 22px rgba(17,24,39,.06);
      }

      .search-wishlist-list-option.is-active{
        border-color:#1f2937;
        background:#fafafa;
      }

      .search-wishlist-list-option__left{
        min-width:0;
        display:flex;
        flex-direction:column;
        gap:4px;
      }

      .search-wishlist-list-option__name{
        font-size:14px;
        line-height:1.25;
        font-weight:700;
        color:#18212f;
        word-break:break-word;
      }

      .search-wishlist-list-option__meta{
        font-size:12px;
        line-height:1.3;
        color:#6b7280;
      }

      .search-wishlist-list-option__action{
        min-width:max-content;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        padding:9px 12px;
        border-radius:999px;
        font-size:12px;
        line-height:1;
        font-weight:700;
        border:1px solid #d9dee7;
        background:#fff;
        color:#18212f;
      }

      .search-wishlist-modal__footer{
        padding:0 18px 18px;
      }

      .search-wishlist-modal__cancel{
        width:100%;
        min-height:46px;
        border:1px solid #d9dee7;
        border-radius:12px;
        background:#fff;
        color:#18212f;
        font-weight:600;
        cursor:pointer;
      }

      .search-wishlist-toast{
        position:fixed;
        left:50%;
        bottom:18px;
        transform:translateX(-50%);
        z-index:10070;
        background:rgba(17,24,39,.92);
        color:#fff;
        padding:12px 14px;
        border-radius:16px;
        box-shadow:0 18px 60px rgba(15,23,42,.30);
        font-size:13px;
        font-weight:800;
        max-width:min(92vw, 560px);
        text-align:center;
        opacity:0;
        pointer-events:none;
        transition:opacity .18s ease, transform .18s ease;
      }

      .search-wishlist-toast.is-visible{
        opacity:1;
        transform:translateX(-50%) translateY(-6px);
      }

      @media (max-width:768px){
        .search-wishlist-modal{
          display:none !important;
        }
      }

      .empty-state{
        display:none;
        width:100%;
        box-sizing:border-box;
        background:#fff;
        border:1px solid #e5e7eb;
        border-radius:16px;
        padding:28px 32px;
        margin-top:8px;
        box-shadow:0 8px 24px rgba(0,0,0,.04);
      }

      .empty-state-title{
        font-size:24px;
        font-weight:700;
        line-height:1.25;
        color:#111827;
        margin:0 0 10px 0;
      }

      .empty-state-text{
        font-size:15px;
        line-height:1.55;
        color:#6b7280;
        margin:0;
      }

      @media (min-width: 769px){
        .empty-state{
          grid-column:1 / -1;
          grid-row:2;
          align-self:start;
          justify-self:start;
          max-width:760px;
        }

        #external-search-modal.is-empty-results #results-scroll{
          display:none !important;
        }
      }

      @media (max-width: 768px){
        .empty-state{
          max-width:none;
          width:100%;
          padding:18px 16px;
          margin-top:10px;
          border-radius:14px;
          box-shadow:none;
        }

        .empty-state-title{
          font-size:18px;
          line-height:1.3;
          margin-bottom:8px;
        }

        .empty-state-text{
          font-size:14px;
          line-height:1.45;
        }

        #external-search-modal.is-empty-results #results-scroll{
          display:none !important;
        }
      }

      .recommended-products{
        display:none;
        width:100%;
        margin-top:18px;
      }

      .recommended-products-head{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        margin-bottom:12px;
      }

      .recommended-products-title{
        font-size:18px;
        font-weight:800;
        color:#111827;
        margin:0;
      }

      .recommended-products-grid{
        display:grid;
        grid-template-columns:repeat(6, minmax(0, 1fr));
        gap:16px;
        align-items:stretch;
      }

      @media (max-width: 1500px){
        .recommended-products-grid{
          grid-template-columns:repeat(5, minmax(0, 1fr));
        }
      }

      @media (max-width: 1280px){
        .recommended-products-grid{
          grid-template-columns:repeat(4, minmax(0, 1fr));
        }
      }

      @media (max-width: 1024px){
        .recommended-products-grid{
          grid-template-columns:repeat(3, minmax(0, 1fr));
        }
      }

      .recommended-card{
        border:1px solid #e5e7eb;
        border-radius:14px;
        background:#fff;
        padding:12px;
        display:flex;
        flex-direction:column;
        min-width:0;
        height:100%;
        box-sizing:border-box;
      }

      .recommended-card-link{
        color:inherit;
        text-decoration:none;
        display:flex;
        flex-direction:column;
        flex:1 1 auto;
        min-width:0;
      }

      .recommended-card-name{
        font-size:14px;
        line-height:1.35;
        min-height:calc(1.35em * 2);
        max-height:calc(1.35em * 2);
        overflow:hidden;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        margin-bottom:8px;
        text-align:center;
      }

      .recommended-card-price{
        font-size:18px;
        font-weight:700;
        text-align:center;
        margin-top:auto;
        margin-bottom:10px;
        color:#111827;
      }

      .recommended-card .add-to-cart{
        width:100%;
        margin-top:0;
      }

      .recommended-card .img{
        margin:0 0 10px;
        border-radius:10px;
      }

      .recommended-loading,
      .recommended-empty{
        font-size:14px;
        color:#6b7280;
      }

      @media (max-width: 768px){
        .recommended-products{
          display:none !important;
        }
      }
    </style>

    <style>
      /* =========================================================
       * REDISEÑO VISUAL V3 - limpio y sobrio
       * Solo cambia apariencia. No modifica lógica, filtros ni carrito.
       * ========================================================= */
      #external-search-modal{
        --es-text:#111827;
        --es-muted:#6b7280;
        --es-bg:#f6f7f9;
        --es-surface:#ffffff;
        --es-surface-2:#f9fafb;
        --es-border:#e5e7eb;
        --es-border-strong:#d1d5db;
        --es-primary:#111827;
        --es-primary-hover:#374151;
        --es-success:#047857;
        --es-success-bg:#ecfdf5;
        --es-shadow:0 8px 22px rgba(17,24,39,.06);
        background:var(--es-bg) !important;
        color:var(--es-text) !important;
        border-top:1px solid var(--es-border) !important;
        box-shadow:none !important;
      }

      #external-search-input{
        width:100% !important;
        height:46px !important;
        padding:0 14px !important;
        border:1px solid #9ca3af !important;
        border-radius:8px !important;
        background:#fff !important;
        color:#111827 !important;
        font-size:15px !important;
        font-weight:400 !important;
        box-shadow:inset 0 0 0 1px rgba(17,24,39,.03) !important;
        outline:none !important;
        transition:border-color .15s ease, box-shadow .15s ease !important;
      }

      #external-search-input::placeholder{ color:#9ca3af !important; }

      #external-search-input:hover{
        border-color:#6b7280 !important;
      }

      #external-search-input:focus{
        border-color:#111827 !important;
        box-shadow:0 0 0 3px rgba(17,24,39,.10) !important;
      }

      #external-search-modal .layout{
        width:min(94vw, 1800px) !important;
        grid-template-columns:280px 1fr !important;
        gap:22px !important;
        padding:20px !important;
      }

      #external-search-modal .filters,
      #external-search-modal .results-wrap{
        background:var(--es-surface) !important;
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        box-shadow:none !important;
        backdrop-filter:none !important;
        -webkit-backdrop-filter:none !important;
      }

      #external-search-modal .filters{
        padding:14px 12px !important;
      }

      #external-search-modal .results-wrap{
        padding:16px !important;
      }

      #external-search-modal .results{
        grid-template-columns:repeat(auto-fill, minmax(210px, 1fr)) !important;
        gap:16px !important;
      }

      #external-search-modal .results-scroll{
        padding:2px 8px 8px 0 !important;
        scrollbar-width:thin;
        scrollbar-color:#c7ccd4 transparent;
      }

      #external-search-modal .results-scroll::-webkit-scrollbar,
      #external-search-modal .filters::-webkit-scrollbar,
      #external-search-modal .drawer-body::-webkit-scrollbar{ width:8px; }

      #external-search-modal .results-scroll::-webkit-scrollbar-track,
      #external-search-modal .filters::-webkit-scrollbar-track,
      #external-search-modal .drawer-body::-webkit-scrollbar-track{ background:transparent; }

      #external-search-modal .results-scroll::-webkit-scrollbar-thumb,
      #external-search-modal .filters::-webkit-scrollbar-thumb,
      #external-search-modal .drawer-body::-webkit-scrollbar-thumb{
        background:#c7ccd4;
        border-radius:999px;
      }

      #external-search-modal .results-count{
        margin:0 !important;
        color:var(--es-muted) !important;
        font-size:14px !important;
      }

      #external-search-modal .results-count strong{
        color:var(--es-text) !important;
        font-size:17px !important;
      }

      #external-search-modal .sort-bar.sort-bar--doo{
        gap:10px !important;
        align-items:center !important;
      }

      #external-search-modal .sort-label{
        color:var(--es-muted) !important;
        font-size:12px !important;
        font-weight:700 !important;
        text-transform:none !important;
        letter-spacing:.02em !important;
      }

      #external-search-modal .sort-bar select,
      #external-search-modal .facet-search{
        min-height:40px !important;
        border:1px solid var(--es-border-strong) !important;
        border-radius:8px !important;
        background:#fff !important;
        color:var(--es-text) !important;
        box-shadow:none !important;
        font-size:13px !important;
      }

      #external-search-modal .sort-bar select:focus,
      #external-search-modal .facet-search:focus{
        outline:none !important;
        border-color:#111827 !important;
        box-shadow:0 0 0 3px rgba(17,24,39,.08) !important;
      }

      #external-search-modal .facet{
        border:0 !important;
        border-bottom:1px solid var(--es-border) !important;
        border-radius:0 !important;
        background:transparent !important;
        box-shadow:none !important;
        margin-bottom:0 !important;
      }

      #external-search-modal .facet:last-child{ border-bottom:0 !important; }

      #external-search-modal .facet-header{
        padding:14px 4px 12px !important;
        background:transparent !important;
      }

      #external-search-modal .facet-title{
        color:var(--es-text) !important;
        font-size:14px !important;
        font-weight:700 !important;
        letter-spacing:0 !important;
      }

      #external-search-modal .facet-chevron{
        width:26px !important;
        height:26px !important;
        display:inline-flex !important;
        align-items:center !important;
        justify-content:center !important;
        border-radius:6px !important;
        background:#f3f4f6 !important;
        color:#6b7280 !important;
        font-size:14px !important;
      }

      #external-search-modal .facet-body{
        padding:0 4px 14px !important;
      }

      #external-search-modal .facet-tools{
        gap:8px !important;
        margin:6px 0 12px !important;
      }

      #external-search-modal .filters label.facet-item,
      #external-search-modal .filters label{
        padding-left:30px !important;
        font-size:13px !important;
        line-height:19px !important;
        color:var(--es-text) !important;
      }

      #external-search-modal .facet-name{
        color:#2f343d !important;
        font-weight:500 !important;
      }

      #external-search-modal .facet-count{
        min-width:24px !important;
        padding:2px 7px !important;
        border-radius:999px !important;
        background:#f3f4f6 !important;
        color:#6b7280 !important;
        font-size:12px !important;
        font-weight:600 !important;
        text-align:center !important;
      }

      #external-search-modal .filters label::before,
      #external-search-modal .filters label.facet-item::before{
        width:18px !important;
        height:18px !important;
        border:1px solid var(--es-border-strong) !important;
        border-radius:4px !important;
        background:#fff !important;
        box-shadow:none !important;
      }

      #external-search-modal .filters label:hover::before,
      #external-search-modal .filters label.facet-item:hover::before{
        background:#f9fafb !important;
        border-color:#9ca3af !important;
      }

      #external-search-modal .filters label:has(input[type="checkbox"]:checked)::before,
      #external-search-modal .filters label.facet-item:has(input[type="checkbox"]:checked)::before{
        background:#111827 !important;
        border-color:#111827 !important;
        box-shadow:inset 0 0 0 4px #fff !important;
      }

      #external-search-modal .facet-more{
        min-height:38px !important;
        border:1px solid var(--es-border-strong) !important;
        border-radius:8px !important;
        background:#fff !important;
        color:#374151 !important;
        font-weight:600 !important;
      }

      #external-search-modal .facet-more:hover{ background:#f9fafb !important; }

      #external-search-modal .card,
      #external-search-modal .recommended-card{
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        background:#fff !important;
        box-shadow:none !important;
        padding:12px !important;
        transition:border-color .15s ease, box-shadow .15s ease, transform .15s ease !important;
      }

      #external-search-modal .card:hover,
      #external-search-modal .recommended-card:hover{
        transform:none !important;
        border-color:#cbd5e1 !important;
        box-shadow:var(--es-shadow) !important;
      }

      #external-search-modal .img{
        margin:0 0 12px !important;
        border-radius:0 !important;
        background:transparent !important;
        border:0 !important;
        box-shadow:none !important;
      }

      #external-search-modal .img img{
        padding:8px !important;
        box-sizing:border-box !important;
        transition:none !important;
      }

      #external-search-modal .card:hover .img img,
      #external-search-modal .recommended-card:hover .img img{ transform:none !important; }

      #external-search-modal .product-name,
      #external-search-modal .recommended-card-name{
        color:var(--es-text) !important;
        font-size:14px !important;
        font-weight:600 !important;
        line-height:1.35 !important;
        text-align:left !important;
        min-height:calc(1.35em * 3) !important;
        max-height:calc(1.35em * 3) !important;
        margin-bottom:8px !important;
      }

      #external-search-modal .product-ids{
        text-align:left !important;
        color:#9ca3af !important;
        font-size:11px !important;
        font-weight:400 !important;
      }

      #external-search-modal .card-meta{ text-align:left !important; }

      #external-search-modal .price,
      #external-search-modal .recommended-card-price{
        color:var(--es-text) !important;
        font-size:20px !important;
        font-weight:700 !important;
        letter-spacing:-.02em !important;
        text-align:left !important;
        margin-bottom:6px !important;
      }

      #external-search-modal .delivery-text{
        display:inline-flex !important;
        align-items:center !important;
        width:auto !important;
        min-height:24px !important;
        margin:0 0 12px !important;
        padding:4px 8px !important;
        border-radius:6px !important;
        background:var(--es-success-bg) !important;
        color:var(--es-success) !important;
        font-size:12px !important;
        font-weight:600 !important;
      }

      #external-search-modal .add-row{ gap:6px !important; }

      #external-search-modal .qty-box{
        flex-basis:68px !important;
        width:68px !important;
        min-width:68px !important;
        max-width:68px !important;
        height:40px !important;
      }

      #external-search-modal .qty-input{
        width:42px !important;
        min-width:42px !important;
        max-width:42px !important;
        height:40px !important;
        border:1px solid var(--es-border-strong) !important;
        border-right:0 !important;
        border-radius:8px 0 0 8px !important;
        background:#fff !important;
        color:var(--es-text) !important;
        font-weight:600 !important;
      }

      #external-search-modal .qty-buttons{
        width:26px !important;
        min-width:26px !important;
        max-width:26px !important;
      }

      #external-search-modal .qty-btn{
        border-color:var(--es-border-strong) !important;
        background:#fff !important;
        color:#374151 !important;
      }

      #external-search-modal .qty-btn:hover{ background:#f3f4f6 !important; }
      #external-search-modal .qty-plus{ border-radius:0 8px 0 0 !important; }
      #external-search-modal .qty-minus{ border-radius:0 0 8px 0 !important; }

      #external-search-modal .add-to-cart,
      #external-search-modal .drawer-apply{
        min-height:40px !important;
        height:40px !important;
        border-radius:8px !important;
        background:var(--es-primary) !important;
        color:#fff !important;
        font-size:14px !important;
        font-weight:700 !important;
        letter-spacing:0 !important;
        box-shadow:none !important;
        transition:background .15s ease, transform .15s ease !important;
      }

      #external-search-modal .add-to-cart:hover,
      #external-search-modal .drawer-apply:hover{
        background:var(--es-primary-hover) !important;
        transform:none !important;
        box-shadow:none !important;
        filter:none !important;
      }

      #external-search-modal .search-wishlist-btn{
        top:10px !important;
        right:10px !important;
        width:34px !important;
        height:34px !important;
        border-radius:8px !important;
        background:rgba(255,255,255,.92) !important;
        border:1px solid var(--es-border) !important;
        box-shadow:0 2px 8px rgba(17,24,39,.08) !important;
        color:#4b5563 !important;
      }

      #external-search-modal .search-wishlist-btn:hover,
      #external-search-modal .search-wishlist-btn.is-active{
        background:#fff !important;
        border-color:#cbd5e1 !important;
        color:#111827 !important;
      }

      #external-search-modal .search-wishlist-btn.is-active svg path,
      #external-search-modal .search-wishlist-btn.is-active .search-wishlist-btn__icon path{
        fill:#111827 !important;
        stroke:#111827 !important;
      }

      #external-search-modal #desktop-search-close{
        border-radius:8px !important;
        background:#fff !important;
        border:1px solid var(--es-border) !important;
        color:#4b5563 !important;
        box-shadow:0 4px 12px rgba(17,24,39,.08) !important;
      }

      #external-search-modal #desktop-search-close:hover{
        background:#f9fafb !important;
        color:#111827 !important;
        transform:none !important;
      }

      #external-search-modal.show-recent{
        background:#f6f7f9 !important;
        border-top:1px solid var(--es-border) !important;
        box-shadow:none !important;
      }

      #external-search-modal.show-recent .results-wrap{
        background:#fff !important;
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        padding:16px !important;
        box-shadow:none !important;
      }

      #external-search-modal .desktop-recent-searches,
      #external-search-modal .recent-searches-card{ color:var(--es-text) !important; }

      #external-search-modal .recent-searches-title{
        color:#374151 !important;
        font-size:12px !important;
        font-weight:700 !important;
        text-transform:none !important;
        letter-spacing:0 !important;
      }

      #external-search-modal .recent-search-chip{
        min-height:30px !important;
        padding:3px 7px 3px 10px !important;
        border:1px solid var(--es-border) !important;
        border-radius:999px !important;
        background:#fff !important;
        box-shadow:none !important;
      }

      #external-search-modal .recent-search-chip-term{
        color:#374151 !important;
        font-weight:500 !important;
      }

      #external-search-modal .recent-search-chip-remove,
      #external-search-modal #desktop-recent-clear{
        color:#6b7280 !important;
        font-weight:600 !important;
      }

      #external-search-modal .recommended-products-title{
        color:var(--es-text) !important;
        font-size:18px !important;
        font-weight:700 !important;
        letter-spacing:0 !important;
      }

      #external-search-modal .empty-state{
        max-width:760px !important;
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        background:#fff !important;
        box-shadow:none !important;
      }

      #external-search-modal .empty-state-title{
        color:var(--es-text) !important;
        font-size:22px !important;
        font-weight:700 !important;
        letter-spacing:0 !important;
      }

      #external-search-modal .empty-state-text{ color:var(--es-muted) !important; }

      #external-search-modal .search-wishlist-modal__dialog{
        border-radius:14px !important;
        background:#fff !important;
        border:1px solid var(--es-border) !important;
        box-shadow:0 24px 60px rgba(17,24,39,.18) !important;
      }

      #external-search-modal .search-wishlist-modal__backdrop{
        background:rgba(17,24,39,.45) !important;
        backdrop-filter:none !important;
        -webkit-backdrop-filter:none !important;
      }

      #external-search-modal .search-wishlist-modal__title{
        color:var(--es-text) !important;
        font-weight:700 !important;
      }

      #external-search-modal .search-wishlist-modal__subtitle,
      #external-search-modal .search-wishlist-list-option__meta{ color:var(--es-muted) !important; }

      #external-search-modal .search-wishlist-list-option{
        border-color:var(--es-border) !important;
        border-radius:10px !important;
        background:#fff !important;
      }

      #external-search-modal .search-wishlist-list-option:hover{
        border-color:#cbd5e1 !important;
        box-shadow:0 8px 22px rgba(17,24,39,.06) !important;
      }

      #external-search-modal .search-wishlist-list-option__action{
        border-color:var(--es-border) !important;
        color:#374151 !important;
        background:#f9fafb !important;
      }

      @media (min-width: 769px){
        #external-search-modal .results-wrap{
          grid-template-columns:1fr auto !important;
          grid-template-rows:auto 1fr !important;
        }
      }

      @media (max-width: 768px){
        #external-search-modal{ background:#f6f7f9 !important; }

        #external-search-modal .mobile-search-header{
          padding:10px !important;
          gap:8px !important;
          background:#fff !important;
          border-bottom:1px solid var(--es-border) !important;
          box-shadow:none !important;
          backdrop-filter:none !important;
          -webkit-backdrop-filter:none !important;
        }

        #external-search-input-mobile{
          height:44px !important;
          padding:0 14px !important;
          border:1px solid #9ca3af !important;
          border-radius:8px !important;
          background:#fff !important;
          color:#111827 !important;
          font-size:15px !important;
          font-weight:400 !important;
          box-shadow:inset 0 0 0 1px rgba(17,24,39,.03) !important;
          outline:none !important;
          transition:border-color .15s ease, box-shadow .15s ease !important;
        }

        #external-search-input-mobile:hover{
          border-color:#6b7280 !important;
        }

        #external-search-input-mobile:focus{
          border-color:#111827 !important;
          box-shadow:0 0 0 3px rgba(17,24,39,.10) !important;
        }

        #external-search-modal #search-clear-btn{
          width:42px !important;
          height:42px !important;
          border-radius:8px !important;
          background:#f3f4f6 !important;
          color:#111827 !important;
          font-size:24px !important;
          box-shadow:none !important;
        }

        #external-search-modal .layout{
          width:100% !important;
          padding:10px !important;
        }

        #external-search-modal .results-wrap{
          padding:10px !important;
          border-radius:12px !important;
          background:#fff !important;
        }

        #external-search-modal .results{
          grid-template-columns:repeat(2, minmax(0, 1fr)) !important;
          gap:10px !important;
        }

        #external-search-modal .card{
          border-radius:10px !important;
          padding:9px !important;
        }

        #external-search-modal .img{
          border-radius:8px !important;
          margin-bottom:9px !important;
        }

        #external-search-modal .img img{ padding:7px !important; }

        #external-search-modal .product-name{
          font-size:13px !important;
          line-height:1.3 !important;
          min-height:calc(1.3em * 3) !important;
          max-height:calc(1.3em * 3) !important;
        }

        #external-search-modal .price{ font-size:18px !important; }

        #external-search-modal .delivery-text{
          min-height:22px !important;
          padding:3px 6px !important;
          font-size:11px !important;
          margin-bottom:9px !important;
        }

        #external-search-modal .add-to-cart{
          min-height:40px !important;
          height:40px !important;
          font-size:13px !important;
        }

        #external-search-modal .mobile-actions{
          gap:8px !important;
          margin:0 0 10px !important;
        }

        #external-search-modal .mobile-actions button,
        #external-search-modal .mobile-filters-toggle{
          min-height:42px !important;
          border-radius:8px !important;
          border:1px solid var(--es-border-strong) !important;
          background:#fff !important;
          color:#111827 !important;
          font-weight:700 !important;
          box-shadow:none !important;
        }

        #external-search-modal .drawer{
          background:#fff !important;
          backdrop-filter:none !important;
          -webkit-backdrop-filter:none !important;
        }

        #external-search-modal .drawer.open{ display:flex !important; }

        #external-search-modal .drawer-header,
        #external-search-modal .drawer-body,
        #external-search-modal .drawer-footer{ background:#fff !important; }

        #external-search-modal .drawer-header{
          border-radius:0 !important;
          border-bottom:1px solid var(--es-border) !important;
          padding:12px !important;
        }

        #external-search-modal .drawer-title{
          color:var(--es-text) !important;
          font-size:16px !important;
          font-weight:700 !important;
        }

        #external-search-modal .drawer-close,
        #external-search-modal .drawer-clear{
          color:#374151 !important;
          font-weight:600 !important;
        }

        #external-search-modal .drawer-body{
          flex:1 !important;
          padding:12px !important;
        }

        #external-search-modal .drawer-footer{
          border-top:1px solid var(--es-border) !important;
          padding:12px !important;
        }

        #external-search-modal .radio-row{
          border-bottom:1px solid var(--es-border) !important;
          color:#111827 !important;
          font-weight:500 !important;
        }

        #external-search-modal.show-recent .results-wrap{
          background:#fff !important;
          border-radius:12px !important;
          padding:12px !important;
        }
      }
    </style>


    <style>
      /* =========================================================
       * REDISEÑO RESPONSIVE V4 - limpio para móvil, tablet y PC
       * Solo cambia la capa visual. Mantiene la lógica original.
       * ========================================================= */

      #external-search-modal{
        --es-text:#0f172a;
        --es-muted:#64748b;
        --es-bg:#f8fafc;
        --es-surface:#ffffff;
        --es-border:#e2e8f0;
        --es-border-strong:#cbd5e1;
        --es-primary:#0f172a;
        --es-primary-hover:#1e293b;
        --es-success:#047857;
        --es-success-bg:#ecfdf5;
        background:var(--es-bg) !important;
        color:var(--es-text) !important;
      }

      #external-search-input,
      #external-search-input-mobile{
        border:1px solid #94a3b8 !important;
        border-radius:8px !important;
        background:#fff !important;
        color:#0f172a !important;
        outline:none !important;
        box-shadow:none !important;
      }

      #external-search-input:hover,
      #external-search-input-mobile:hover{
        border-color:#64748b !important;
      }

      #external-search-input:focus,
      #external-search-input-mobile:focus{
        border-color:#0f172a !important;
        box-shadow:0 0 0 3px rgba(15,23,42,.10) !important;
      }

      #external-search-modal .layout{
        width:min(96vw, 1800px) !important;
        grid-template-columns:280px minmax(0,1fr) !important;
        gap:20px !important;
        padding:18px !important;
      }

      #external-search-modal .filters,
      #external-search-modal .results-wrap{
        background:#fff !important;
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        box-shadow:none !important;
      }

      #external-search-modal .filters{
        padding:14px 12px !important;
      }

      #external-search-modal .results-wrap{
        padding:16px !important;
      }

      #external-search-modal .results{
        grid-template-columns:repeat(auto-fill, minmax(205px, 1fr)) !important;
        gap:16px !important;
      }

      #external-search-modal .card,
      #external-search-modal .recommended-card{
        background:#fff !important;
        border:1px solid var(--es-border) !important;
        border-radius:12px !important;
        padding:12px !important;
        box-shadow:none !important;
        overflow:hidden !important;
      }

      #external-search-modal .card:hover,
      #external-search-modal .recommended-card:hover{
        border-color:#cbd5e1 !important;
        box-shadow:0 8px 20px rgba(15,23,42,.06) !important;
        transform:none !important;
      }

      #external-search-modal .img,
      #external-search-modal .recommended-card .img{
        margin:0 0 12px !important;
        aspect-ratio:1 / 1 !important;
        background:transparent !important;
        border:0 !important;
        border-radius:0 !important;
        box-shadow:none !important;
      }

      #external-search-modal .img img{
        width:100% !important;
        height:100% !important;
        object-fit:contain !important;
        padding:6px !important;
        box-sizing:border-box !important;
      }

      #external-search-modal .product-name,
      #external-search-modal .recommended-card-name{
        color:var(--es-text) !important;
        text-align:left !important;
        font-size:14px !important;
        line-height:1.35 !important;
        font-weight:650 !important;
        min-height:calc(1.35em * 3) !important;
        max-height:calc(1.35em * 3) !important;
        margin-bottom:8px !important;
      }

      #external-search-modal .card-meta{
        text-align:left !important;
      }

      #external-search-modal .price,
      #external-search-modal .recommended-card-price{
        color:var(--es-text) !important;
        text-align:left !important;
        font-size:20px !important;
        line-height:1.15 !important;
        font-weight:750 !important;
        margin:0 0 7px !important;
      }

      #external-search-modal .delivery-text{
        display:inline-block !important;
        width:auto !important;
        max-width:100% !important;
        min-height:0 !important;
        margin:0 0 12px !important;
        padding:4px 8px !important;
        border-radius:6px !important;
        background:var(--es-success-bg) !important;
        color:var(--es-success) !important;
        font-size:12px !important;
        line-height:1.2 !important;
        font-weight:700 !important;
        white-space:normal !important;
      }

      #external-search-modal .add-to-cart,
      #external-search-modal .drawer-apply{
        height:40px !important;
        min-height:40px !important;
        border-radius:8px !important;
        background:#7fc42b !important;
        color:#fff !important;
        border:0 !important;
        font-size:14px !important;
        font-weight:800 !important;
        box-shadow:none !important;
      }

      #external-search-modal .add-to-cart:hover,
      #external-search-modal .drawer-apply:hover{
        background:#7fc42b !important;
        transform:none !important;
      }

      #external-search-modal .facet{
        border:0 !important;
        border-bottom:1px solid var(--es-border) !important;
        border-radius:0 !important;
        background:transparent !important;
        margin:0 !important;
      }

      #external-search-modal .facet-header{
        padding:14px 4px 12px !important;
        background:transparent !important;
      }

      #external-search-modal .facet-title{
        font-size:14px !important;
        font-weight:800 !important;
        color:var(--es-text) !important;
      }

      #external-search-modal .facet-search,
      #external-search-modal .sort-bar select{
        border:1px solid var(--es-border-strong) !important;
        border-radius:8px !important;
        background:#fff !important;
        color:var(--es-text) !important;
        box-shadow:none !important;
      }

      #external-search-modal .facet-count{
        background:#f1f5f9 !important;
        color:#475569 !important;
        border-radius:999px !important;
        padding:2px 7px !important;
        font-weight:700 !important;
      }

      #external-search-modal .filters label::before,
      #external-search-modal .filters label.facet-item::before{
        width:18px !important;
        height:18px !important;
        border:1px solid var(--es-border-strong) !important;
        border-radius:4px !important;
        background:#fff !important;
        box-shadow:none !important;
      }

      #external-search-modal .filters label:has(input[type="checkbox"]:checked)::before,
      #external-search-modal .filters label.facet-item:has(input[type="checkbox"]:checked)::before{
        background:#0f172a !important;
        border-color:#0f172a !important;
        box-shadow:inset 0 0 0 4px #fff !important;
      }

      #external-search-modal .search-wishlist-btn{
        background:rgba(255,255,255,.95) !important;
        border:1px solid var(--es-border) !important;
        box-shadow:0 2px 8px rgba(15,23,42,.08) !important;
        border-radius:8px !important;
      }

      #external-search-modal .results-scroll{
        min-width:0 !important;
        scrollbar-width:thin;
        scrollbar-color:#cbd5e1 transparent;
      }

      #external-search-modal .results-scroll::-webkit-scrollbar,
      #external-search-modal .filters::-webkit-scrollbar,
      #external-search-modal .drawer-body::-webkit-scrollbar{
        width:7px;
      }

      #external-search-modal .results-scroll::-webkit-scrollbar-thumb,
      #external-search-modal .filters::-webkit-scrollbar-thumb,
      #external-search-modal .drawer-body::-webkit-scrollbar-thumb{
        background:#cbd5e1;
        border-radius:999px;
      }

      /* Tablet */
      @media (min-width:769px) and (max-width:1180px){
        #external-search-modal .layout{
          width:100% !important;
          grid-template-columns:240px minmax(0,1fr) !important;
          gap:14px !important;
          padding:14px !important;
        }

        #external-search-modal .results-wrap{
          padding:14px !important;
        }

        #external-search-modal .results{
          grid-template-columns:repeat(auto-fill, minmax(175px, 1fr)) !important;
          gap:14px !important;
        }

        #external-search-modal .product-name{
          font-size:13px !important;
        }

        #external-search-modal .price{
          font-size:18px !important;
        }
      }

      /* Móvil */
      @media (max-width:768px){
        #external-search-modal{
          top:0 !important;
          left:0 !important;
          right:0 !important;
          width:100vw !important;
          height:100dvh !important;
          max-height:100dvh !important;
          background:#fff !important;
          border:0 !important;
          display:flex !important;
          flex-direction:column !important;
          overflow:hidden !important;
        }

        #external-search-modal .mobile-search-header{
          flex:0 0 auto !important;
          display:flex !important;
          align-items:center !important;
          gap:8px !important;
          padding:10px !important;
          background:#fff !important;
          border-bottom:1px solid var(--es-border) !important;
          box-shadow:none !important;
          position:relative !important;
          top:auto !important;
          z-index:10 !important;
        }

        #external-search-input-mobile{
          flex:1 1 auto !important;
          min-width:0 !important;
          height:42px !important;
          padding:0 12px !important;
          font-size:15px !important;
        }

        #external-search-modal #search-clear-btn{
          flex:0 0 42px !important;
          width:42px !important;
          height:42px !important;
          border-radius:8px !important;
          background:#f1f5f9 !important;
          color:#0f172a !important;
          font-size:22px !important;
          border:0 !important;
        }

        #external-search-modal .layout{
          width:100% !important;
          max-width:none !important;
          height:calc(100dvh - 63px) !important;
          margin:0 !important;
          padding:10px !important;
          display:block !important;
          overflow:hidden !important;
          box-sizing:border-box !important;
        }

        #external-search-modal .filters{
          display:none !important;
        }

        #external-search-modal .results-wrap{
          width:100% !important;
          height:100% !important;
          padding:0 !important;
          border:0 !important;
          border-radius:0 !important;
          background:#fff !important;
          display:flex !important;
          flex-direction:column !important;
          overflow:hidden !important;
          box-shadow:none !important;
        }

        #external-search-modal .mobile-actions{
          flex:0 0 auto !important;
          display:grid !important;
          grid-template-columns:1fr 1fr !important;
          gap:8px !important;
          margin:0 0 8px !important;
        }

        #external-search-modal .mobile-actions button{
          min-height:40px !important;
          padding:0 10px !important;
          border-radius:8px !important;
          border:1px solid var(--es-border-strong) !important;
          background:#fff !important;
          color:#0f172a !important;
          font-size:14px !important;
          font-weight:800 !important;
          box-shadow:none !important;
        }

        #external-search-modal .results-count{
          flex:0 0 auto !important;
          margin:0 0 10px !important;
          font-size:13px !important;
          color:var(--es-muted) !important;
        }

        #external-search-modal .results-count strong{
          color:var(--es-text) !important;
          font-size:17px !important;
        }

        #external-search-modal .sort-bar.sort-bar--doo{
          display:none !important;
        }

        #external-search-modal .results-scroll{
          flex:1 1 auto !important;
          min-height:0 !important;
          overflow-y:auto !important;
          overflow-x:hidden !important;
          padding:0 4px 16px 0 !important;
          -webkit-overflow-scrolling:touch !important;
        }

        #external-search-modal .results{
          grid-template-columns:repeat(2, minmax(0, 1fr)) !important;
          gap:10px !important;
          margin:0 !important;
        }

        #external-search-modal .card{
          min-width:0 !important;
          padding:9px !important;
          border-radius:10px !important;
          border:1px solid var(--es-border) !important;
          background:#fff !important;
        }

        #external-search-modal .card:hover{
          box-shadow:none !important;
          border-color:var(--es-border) !important;
        }

        #external-search-modal .img{
          margin:0 0 8px !important;
          aspect-ratio:1 / .92 !important;
          background:transparent !important;
          border:0 !important;
          border-radius:0 !important;
        }

        #external-search-modal .img img{
          padding:2px !important;
        }

        #external-search-modal .product-name{
          font-size:12.5px !important;
          line-height:1.25 !important;
          font-weight:700 !important;
          min-height:calc(1.25em * 3) !important;
          max-height:calc(1.25em * 3) !important;
          margin-bottom:7px !important;
        }

        #external-search-modal .price{
          font-size:17px !important;
          line-height:1.1 !important;
          margin-bottom:6px !important;
        }

        #external-search-modal .delivery-text{
          display:block !important;
          width:fit-content !important;
          max-width:100% !important;
          padding:4px 6px !important;
          font-size:10.5px !important;
          line-height:1.12 !important;
          border-radius:6px !important;
          margin-bottom:8px !important;
        }

        #external-search-modal .add-row{
          display:block !important;
          width:100% !important;
        }

        #external-search-modal .qty-box,
        #external-search-modal .search-wishlist-btn{
          display:none !important;
        }

        #external-search-modal .add-to-cart{
          width:100% !important;
          height:38px !important;
          min-height:38px !important;
          font-size:13px !important;
          border-radius:8px !important;
        }

        #external-search-modal .drawer{
          position:fixed !important;
          inset:0 !important;
          width:100vw !important;
          height:100dvh !important;
          background:#fff !important;
          z-index:10050 !important;
        }

        #external-search-modal .drawer-header{
          padding:10px 12px !important;
          border-bottom:1px solid var(--es-border) !important;
          background:#fff !important;
        }

        #external-search-modal .drawer-body{
          padding:12px !important;
          background:#fff !important;
        }

        #external-search-modal .drawer-footer{
          padding:12px !important;
          border-top:1px solid var(--es-border) !important;
          background:#fff !important;
        }

        #external-search-modal .drawer-apply{
          height:44px !important;
          min-height:44px !important;
        }

        #external-search-modal.show-recent{
          background:#fff !important;
          overflow:hidden !important;
        }

        #external-search-modal.show-recent .layout{
          height:calc(100dvh - 63px) !important;
          padding:10px !important;
          overflow:auto !important;
        }

        #external-search-modal.show-recent .results-wrap{
          height:auto !important;
          min-height:0 !important;
          padding:12px !important;
          border:1px solid var(--es-border) !important;
          border-radius:12px !important;
        }
      }

      /* Móvil muy estrecho */
      @media (max-width:360px){
        #external-search-modal .results{
          grid-template-columns:1fr !important;
        }

        #external-search-modal .img{
          aspect-ratio:1 / .7 !important;
        }

        #external-search-modal .product-name{
          min-height:auto !important;
          max-height:calc(1.25em * 3) !important;
        }
      }
    </style>


    <style>
      /* =========================================================
       * FIX: el modal NO debe abrirse solo al cargar la página.
       * La versión responsive anterior tenía display:flex !important
       * en móvil y eso pisaba el display:none inicial del JS.
       * ========================================================= */

      @media (max-width:768px){
        #external-search-modal[style*="display: none"]{
          display:none !important;
        }

        #external-search-modal[style*="display: block"]{
          display:flex !important;
          flex-direction:column !important;
        }
      }
    </style>


    <button id="desktop-search-close" type="button" aria-label="Cerrar búsqueda">×</button>

    <div class="mobile-search-header">
      <input
        id="external-search-input-mobile"
        type="text"
        placeholder="Busca entre más de 400.000 productos..."
        autocomplete="off"
        style="flex:1;padding:12px 14px;font-size:16px;border:1px solid #ddd;border-radius:6px;"
      />
      <button
        id="search-clear-btn"
        aria-label="Cerrar búsqueda"
        style="
          background:none;
          border:none;
          font-size:22px;
          cursor:pointer;
          line-height:1;
        "
      >×</button>
    </div>

    <div id="filters-drawer" class="drawer" aria-hidden="true">
      <div class="drawer-header">
        <button id="filters-close" class="drawer-close" type="button">×</button>
        <div class="drawer-title">Filtros</div>
        <button id="filters-clear" class="drawer-clear" type="button">Borrar</button>
      </div>

      <div class="drawer-body">
        <div class="facet" data-key="manufacturers">
          <button class="facet-header" type="button">
            <span class="facet-title">Marcas</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="df-manufacturers" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="shopify_colors">
          <button class="facet-header" type="button">
            <span class="facet-title">Color</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="df-shopify-colors" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="categories">
          <button class="facet-header" type="button">
            <span class="facet-title">Categorías</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="df-categories" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="tiempos">
          <button class="facet-header" type="button">
            <span class="facet-title">Plazo entrega</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="df-tiempos" class="facet-list"></div>
          </div>
        </div>
      </div>

      <div class="drawer-footer">
        <button id="filters-apply" class="drawer-apply" type="button">Aplicar filtros</button>
      </div>
    </div>

    <div id="sort-drawer" class="drawer" aria-hidden="true">
      <div class="drawer-header">
        <button id="sort-close" class="drawer-close" type="button">×</button>
        <div class="drawer-title">Ordenar</div>
        <div style="width:64px"></div>
      </div>

      <div class="drawer-body">
        <label class="radio-row"><input type="radio" name="sort-option" value="score_desc"> Relevancia</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="pricewithtax_asc"> Precio más bajo</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="pricewithtax_desc"> Precio más alto</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="stock_desc"> Más stock</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="stock_asc"> Menos stock</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="tiempo_entrega_asc"> Entrega antes</label>
        <label class="radio-row"><input type="radio" name="sort-option" value="tiempo_entrega_desc"> Entrega más tarde</label>
      </div>

      <div class="drawer-footer">
        <button id="sort-apply" class="drawer-apply" type="button">Aplicar orden</button>
      </div>
    </div>

    <div id="search-wishlist-modal" class="search-wishlist-modal" hidden>
      <div class="search-wishlist-modal__backdrop" data-close-search-wishlist="true"></div>

      <div
        class="search-wishlist-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="search-wishlist-modal-title"
      >
        <div class="search-wishlist-modal__header">
          <div>
            <h3 id="search-wishlist-modal-title" class="search-wishlist-modal__title">Elegir lista</h3>
            <p class="search-wishlist-modal__subtitle">Selecciona dónde quieres guardar este producto.</p>
          </div>

          <button
            type="button"
            class="search-wishlist-modal__close"
            data-close-search-wishlist="true"
            aria-label="Cerrar"
          >×</button>
        </div>

        <div class="search-wishlist-modal__body" id="search-wishlist-modal-body"></div>

        <div class="search-wishlist-modal__footer">
          <button
            type="button"
            class="search-wishlist-modal__cancel"
            data-close-search-wishlist="true"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>

    <div id="search-wishlist-toast" class="search-wishlist-toast" aria-live="polite" aria-atomic="true"></div>

    <div class="layout">
      <aside class="filters">

        <div class="facet" data-key="manufacturers">
          <button class="facet-header" type="button">
            <span class="facet-title">Marcas</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="f-manufacturers" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="shopify_colors">
          <button class="facet-header" type="button">
            <span class="facet-title">Color</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="f-shopify-colors" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="categories">
          <button class="facet-header" type="button">
            <span class="facet-title">Categorías</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="f-categories" class="facet-list"></div>
          </div>
        </div>

        <div class="facet" data-key="tiempos">
          <button class="facet-header" type="button">
            <span class="facet-title">Plazo entrega</span>
            <span class="facet-chevron">▾</span>
          </button>
          <div class="facet-body">
            <div id="f-tiempos" class="facet-list"></div>
          </div>
        </div>

      </aside>

      <section class="results-wrap">

        <div id="desktop-recent-searches" class="desktop-recent-searches recent-searches-card" style="display:none;">
          <div class="recent-searches-inline">
            <div id="desktop-recent-inline-flow" class="recent-searches-flow">
              <span id="desktop-recent-title" class="recent-searches-title">Últimas búsquedas:</span>
              <span id="desktop-recent-searches-list"></span>
              <button id="desktop-recent-clear" type="button">Eliminar todas</button>
            </div>
          </div>
        </div>

        <div id="recommended-products" class="recommended-products">
          <div class="recommended-products-head">
            <h3 class="recommended-products-title">Productos recomendados</h3>
          </div>
          <div id="recommended-products-grid" class="recommended-products-grid"></div>
        </div>

        <div class="mobile-actions">
          <button id="mobile-order-btn" type="button">Ordenar</button>
          <button id="mobile-filter-btn" type="button">Filtrar</button>
        </div>

        <div class="results-count">
          <strong><span id="total">0</span></strong> resultados
        </div>

        <div id="empty-state" class="empty-state">
          <div class="empty-state-title">No hemos encontrado resultados para tu búsqueda.</div>
          <div class="empty-state-text">
            Revisa si hay algún error de ortografía o prueba con otro término más general.
          </div>
        </div>

        <div class="sort-bar sort-bar--doo">
          <div class="sort-left">
            <button class="mobile-filters-toggle" type="button">Filtros</button>
          </div>

          <div class="sort-right">
            <span class="sort-label">Ordenados por:</span>
            <select id="sort-select">
              <option value="stock_desc">Stock (Más stock)</option>
              <option value="stock_asc">Stock (Menos stock)</option>
              <option value="score_desc">Relevancia</option>
              <option value="tiempo_entrega_asc">Entrega (Antes)</option>
              <option value="tiempo_entrega_desc">Entrega (Más tarde)</option>
              <option value="pricewithtax_asc">Precio (Menor a Mayor)</option>
              <option value="pricewithtax_desc">Precio (Mayor a menor)</option>
            </select>
          </div>
        </div>

        <div class="results-scroll" id="results-scroll">
          <div id="results" class="results"></div>
        </div>
      </section>
    </div>
  `;

  document.body.appendChild(modal);

  function openMobileSearchAndFocus() {
    modal.style.display = "block";
    document.body.classList.add("search-open");
    positionModal();

    input.style.visibility = "hidden";

    const mi = getMobileInput();
    if (!mi) return;

    mi.value = query || "";
    modal.classList.add("show-recent");
    toggleEmptyState(false);
    renderRecentSearches();
    showRecommendedProducts(true);
    fetchRecommendedProducts();

    void modal.offsetHeight;
    mi.focus();

    try { mi.setSelectionRange(mi.value.length, mi.value.length); } catch {}
  }

  function closeSearch() {
    modal.style.display = "none";
    document.body.classList.remove("search-open");
    closeRecentSearchesBox();
    closeSearchWishlistModal();

    input.style.visibility = "";
    input.value = "";
    query = "";

    const mobileInput = getMobileInput();
    if (mobileInput) {
      mobileInput.value = "";
      mobileInput.blur();
    }

    finished = false;
    page = 1;

    filtersDrawer?.classList.remove("open");
    sortDrawer?.classList.remove("open");

    toggleEmptyState(false);
    showRecommendedProducts(false);
    setHasResults(0);
  }

  function positionModal() {
    if (window.innerWidth <= 768) {
      modal.style.top = "0";
      modal.style.height = modal.classList.contains("show-recent") ? "auto" : "100vh";
      modal.style.maxHeight = "";
      return;
    }

    const OFFSET = 12;
    const inputRect = input.getBoundingClientRect();
    const top = inputRect.bottom + OFFSET;

    modal.style.top = top + "px";

    if (modal.classList.contains("show-recent")) {
      modal.style.height = "auto";
      modal.style.maxHeight = `calc(100vh - ${top}px - 8px)`;
    } else {
      modal.style.height = `calc(100vh - ${top}px)`;
      modal.style.maxHeight = "";
    }
  }

  window.addEventListener("resize", positionModal);
  window.addEventListener("resize", updateAddToCartButtonsText);
  positionModal();

  let query = "";
  let page = 1;
  let loading = false;
  let finished = false;
  let sortBy = "stock";
  let sortOrder = "desc";
  let lastQuery = "";
  let lastFacets = {
    categories_counts: {},
    manufacturers_counts: {},
    tiempos_counts: {},
    shopify_colors_counts: {}
  };

  const FALLBACK_IMG = "https://cdn.shopify.com/s/files/1/0868/4136/0701/files/Imagen_no_disponible_svg.png?v=1772117227";
  const RECOMMENDED_COLLECTION_HANDLE = "top-ventas";
  const RECOMMENDED_PRODUCTS_MAX_ROWS = 2;
  const RECOMMENDED_PRODUCTS_FETCH = 24;

  let recommendedProductsLoaded = false;
  let recommendedProductsLoading = false;
  let recommendedProductsCache = [];
  const ES_DAYS = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];
  const ES_MONTHS = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

  function _ymd(d){
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
  }
  function _isWeekend(d){
    const g = d.getDay();
    return g === 0 || g === 6;
  }
  function _fmtEsDate(d){
    return `${ES_DAYS[d.getDay()]} ${d.getDate()} de ${ES_MONTHS[d.getMonth()]}`;
  }
  function _normalizePlazo(s){
    return (s || "")
      .toString()
      .replace(/\s+/g, " ")
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }
  function _afterCutoffSpainLocal(now){
    const dow = now.getDay();
    const minutes = now.getHours()*60 + now.getMinutes();
    const cutoff = (dow === 5) ? (14*60+30) : (16*60);
    return minutes >= cutoff;
  }
  function _addBusinessDaysFromTomorrow(now, businessDays){
    const d = new Date(now);
    d.setDate(d.getDate() + 1);

    let added = 0;
    while (added < businessDays) {
      if (!_isWeekend(d)) added++;
      if (added < businessDays) d.setDate(d.getDate() + 1);
    }
    return d;
  }
  function _nextWeekdayFromNow(now, targetDow){
    const d = new Date(now);
    for (let i = 0; i < 14; i++) {
      if (d.getDay() === targetDow) return d;
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function formatPlazoBuscador(p, mode = "card") {
    if (shouldShowViewInsteadOfAdd(p)) {
      return "Consultar";
    }

    const now = new Date();
    const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);

    const stockNum = Number(p && p.stock ? p.stock : 0);
    const raw = stockNum > 0 ? "24 horas" : (p && p.tiempo_entrega_proveedor ? p.tiempo_entrega_proveedor : "");

    const norm = _normalizePlazo(raw);
    if (!norm) return "";

    const dow = now.getDay();
    const afterCutoff = _afterCutoffSpainLocal(now);

    let startDate = null;
    let endDate = null;

    const is24 =
      norm.includes("24") &&
      (norm.includes("hora") || norm.includes("h") || norm.includes("24h"));

    if (is24) {
      const thuAfter = (dow === 4 && afterCutoff);
      const friBefore = (dow === 5 && !afterCutoff);
      const friAfter = (dow === 5 && afterCutoff);
      const weekend = (dow === 6 || dow === 0);

      if (thuAfter || friBefore) {
        startDate = _nextWeekdayFromNow(now, 1);
        endDate = startDate;
      } else if (friAfter || weekend) {
        startDate = _nextWeekdayFromNow(now, 2);
        endDate = startDate;
      } else {
        const days = (afterCutoff && dow >= 1 && dow <= 3) ? 2 : 1;
        startDate = _addBusinessDaysFromTomorrow(now, days);
        endDate = startDate;
      }
    }

    if (!startDate && norm.includes("dia")) {
      const cleaned = norm
        .replace(/dias habiles/g, "")
        .replace(/dia habil/g, "")
        .trim();

      let a = 0, b = 0;
      let m = cleaned.match(/(\d+)\s*(?:a|-)\s*(\d+)/);
      if (m) {
        a = Number(m[1]); b = Number(m[2]);
      } else {
        m = cleaned.match(/(\d+)/);
        if (m) { a = Number(m[1]); b = a; }
      }

      if (a > 0) {
        if (afterCutoff) { a += 1; b += 1; }
        startDate = _addBusinessDaysFromTomorrow(now, a);
        endDate = _addBusinessDaysFromTomorrow(now, b);
      }
    }

    if (!startDate || !endDate) {
      return (p && p.tiempo_entrega_proveedor ? p.tiempo_entrega_proveedor : "").toString().replace(/\s+/g, " ").trim();
    }

    if (_ymd(startDate) === _ymd(endDate) && _ymd(startDate) === _ymd(tomorrow)) {
      return "Recíbelo Mañana";
    }
    if (_ymd(startDate) === _ymd(endDate)) {
      return `Recíbelo el ${_fmtEsDate(startDate)}`;
    }

    if (mode === "card") {
      return `Recíbelo a partir del ${_fmtEsDate(startDate)}`;
    }
    return `Recíbelo entre ${_fmtEsDate(startDate)} y ${_fmtEsDate(endDate)}`;
  }

  const filters = {
    categories: new Set(),
    manufacturers: new Set(),
    tiempos: new Set(),
    shopify_colors: new Set()
  };

  const resultsEl = modal.querySelector("#results");
  const filtersEl = modal.querySelector(".filters");
  const filtersToggle = modal.querySelector(".mobile-filters-toggle");
  const resultsScroll = modal.querySelector("#results-scroll");
  const totalEl = modal.querySelector("#total");
  const emptyStateEl = modal.querySelector("#empty-state");
  const recommendedProductsEl = modal.querySelector("#recommended-products");
  const recommendedProductsGridEl = modal.querySelector("#recommended-products-grid");
  const desktopRecentListEl = modal.querySelector("#desktop-recent-searches-list");
  const desktopRecentClearEl = modal.querySelector("#desktop-recent-clear");
  const catEl = modal.querySelector("#f-categories");
  const manEl = modal.querySelector("#f-manufacturers");
  const timeEl = modal.querySelector("#f-tiempos");
  const colorEl = modal.querySelector("#f-shopify-colors");

  const searchWishlistModal = modal.querySelector("#search-wishlist-modal");
  const searchWishlistModalBody = modal.querySelector("#search-wishlist-modal-body");
  const searchWishlistModalSubtitle = modal.querySelector(".search-wishlist-modal__subtitle");
  const searchWishlistToast = modal.querySelector("#search-wishlist-toast");

  if (filtersToggle && filtersEl) {
    filtersToggle.addEventListener("click", () => {
      const open = filtersEl.classList.toggle("open");
      filtersToggle.textContent = open ? "Ocultar filtros" : "Mostrar filtros";
    });
  }

  function renderRecentSearches() {
    if (!desktopRecentListEl) return;

    const items = getRecentSearches();

    if (!items.length) {
      desktopRecentListEl.innerHTML = '<div class="recent-search-empty">No hay búsquedas recientes.</div>';
      if (desktopRecentClearEl) desktopRecentClearEl.style.display = "none";
      return;
    }

    if (desktopRecentClearEl) desktopRecentClearEl.style.display = "inline-block";

    desktopRecentListEl.innerHTML = items.map(term => `
      <div class="recent-search-chip">
        <button class="recent-search-chip-term" type="button" data-term="${escapeHtml(term)}">${escapeHtml(term)}</button>
        <button class="recent-search-chip-remove" type="button" data-remove-term="${escapeHtml(term)}">×</button>
      </div>
    `).join("");
  }

  function buildLocaleAwareUrl(path) {
    const rootPath =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
        ? window.Shopify.routes.root
        : "/";

    return `${rootPath.replace(/\/$/, "")}${path}`;
  }

  function formatRecommendedPrice(price) {
    let amount = Number(price || 0);
    if (!Number.isFinite(amount) || amount <= 0) return "";

    const rate = getCurrentRate();

    if (rate !== "1" && rate !== "2") {
      amount = Math.round(amount * 1.21 * 100) / 100;
    }

    return amount.toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " €";
  }

  function getRecommendedVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(v => v && v.available) || product.variants[0] || null;
  }

  function getRecommendedImage(product) {
    if (!product || !Array.isArray(product.images) || !product.images.length) {
      return FALLBACK_IMG;
    }

    const first = product.images[0];
    if (typeof first === "string") return first;
    if (first && first.src) return first.src;

    return FALLBACK_IMG;
  }

  function shuffleArray(array) {
    const arr = [...array];

    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
  }

  function getRecommendedProductsColumns() {
    if (isMobile()) return 0;

    const width = window.innerWidth;

    if (width <= 1024) return 3;
    if (width <= 1280) return 4;
    if (width <= 1500) return 5;
    return 6;
  }

  function getRecommendedProductsVisibleCount() {
    return getRecommendedProductsColumns() * RECOMMENDED_PRODUCTS_MAX_ROWS;
  }

  function refreshRecommendedProductsLayout() {
    if (isMobile()) return;
    if (!recommendedProductsLoaded) return;
    if (!recommendedProductsCache.length) return;
    if (!recommendedProductsEl) return;
    if (recommendedProductsEl.style.display === "none") return;

    renderRecommendedProducts(recommendedProductsCache);
  }

  window.addEventListener("resize", refreshRecommendedProductsLayout);

  function showRecommendedProducts(show) {
    if (!recommendedProductsEl) return;

    if (isMobile()) {
      recommendedProductsEl.style.display = "none";
      return;
    }

    recommendedProductsEl.style.display = show ? "block" : "none";

    if (show && recommendedProductsCache.length) {
      renderRecommendedProducts(recommendedProductsCache);
    }
  }

  function renderRecommendedProducts(products) {
    if (!recommendedProductsGridEl) return;

    const visibleCount = getRecommendedProductsVisibleCount();
    const visibleProducts = Array.isArray(products) ? products.slice(0, visibleCount) : [];

    if (!visibleProducts.length) {
      recommendedProductsGridEl.innerHTML = '<div class="recommended-empty">No hay productos recomendados.</div>';
      positionModal();
      return;
    }

    recommendedProductsGridEl.innerHTML = visibleProducts.map(product => {
      const image = getRecommendedImage(product);
      const variant = getRecommendedVariant(product);
      const priceText = formatRecommendedPrice(variant && variant.price);
      const variantId = variant ? variant.id : "";

      return `
        <div class="recommended-card">
          <a class="recommended-card-link" href="/products/${escapeHtml(product.handle || "")}">
            <div class="img">
              <img
                src="${escapeHtml(image)}"
                alt="${escapeHtml(product.title || "")}"
                loading="lazy"
                onerror="this.onerror=null;this.src='${FALLBACK_IMG}';"
              />
            </div>

            <div class="recommended-card-name">${escapeHtml(product.title || "")}</div>
          </a>

          ${priceText ? `<div class="recommended-card-price">${priceText}</div>` : `<div class="recommended-card-price"></div>`}

          ${
            variantId
              ? `<button type="button" class="add-to-cart recommended-add-to-cart" data-variant="${escapeHtml(String(variantId))}">${getAddToCartLabel()}</button>`
              : `<div style="font-size:12px;color:#999;text-align:center;">No disponible online</div>`
          }
        </div>
      `;
    }).join("");

    updateAddToCartButtonsText();
    positionModal();
  }

  async function fetchRecommendedProducts() {
    if (isMobile()) return;
    if (recommendedProductsLoaded || recommendedProductsLoading) return;
    if (!recommendedProductsGridEl) return;

    recommendedProductsLoading = true;
    recommendedProductsGridEl.innerHTML = '<div class="recommended-loading">Cargando productos recomendados...</div>';

    try {
      const url = buildLocaleAwareUrl(`/collections/${RECOMMENDED_COLLECTION_HANDLE}/products.json?limit=${RECOMMENDED_PRODUCTS_FETCH}`);
      const res = await fetch(url, {
        method: "GET",
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      });

      if (!res.ok) {
        throw new Error("No se pudieron cargar los recomendados.");
      }

      const data = await res.json();
      const allProducts = Array.isArray(data.products) ? data.products : [];

      recommendedProductsCache = shuffleArray(allProducts);
      renderRecommendedProducts(recommendedProductsCache);
      recommendedProductsLoaded = true;
    } catch (err) {
      console.error("Error cargando recomendados", err);
      showRecommendedProducts(false);
    } finally {
      recommendedProductsLoading = false;
    }
  }

  function openEmptyState() {
    modal.style.display = "block";
    document.body.classList.add("search-open");
    modal.classList.remove("has-results");
    modal.classList.add("show-recent");
    toggleEmptyState(false);
    renderRecentSearches();
    showRecommendedProducts(true);
    fetchRecommendedProducts();
    positionModal();
  }

  function openRecentSearchesBox() {
    openEmptyState();
  }

  function closeRecentSearchesBox() {
    modal.classList.remove("show-recent");
    showRecommendedProducts(false);
  }

  function setHasResults(n) {
    modal.classList.toggle("has-results", Number(n) > 0);
  }

  function toggleEmptyState(show) {
    if (!emptyStateEl) return;
    emptyStateEl.style.display = show ? "block" : "none";
    modal.classList.toggle("is-empty-results", !!show);
  }

  function buildFilterParams() {
    const p = new URLSearchParams();
    filters.categories.forEach(v => p.append("categories", v));
    filters.manufacturers.forEach(v => p.append("manufacturers", v));
    filters.tiempos.forEach(v => p.append("tiempo_entrega_proveedors", v));
    filters.shopify_colors.forEach(v => p.append("shopify_colors", v));
    return p.toString();
  }

  function clearAllFilters() {
    filters.categories.clear();
    filters.manufacturers.clear();
    filters.tiempos.clear();
    filters.shopify_colors.clear();

    modal.querySelectorAll(".facet-item input[type='checkbox']").forEach(cb => {
      cb.checked = false;
    });
  }

  function cloneCurrentFilters() {
    return {
      categories: new Set(filters.categories),
      manufacturers: new Set(filters.manufacturers),
      tiempos: new Set(filters.tiempos),
      shopify_colors: new Set(filters.shopify_colors)
    };
  }

  function applyPendingFilters(pending) {
    filters.categories.clear(); pending.categories.forEach(v => filters.categories.add(v));
    filters.manufacturers.clear(); pending.manufacturers.forEach(v => filters.manufacturers.add(v));
    filters.tiempos.clear(); pending.tiempos.forEach(v => filters.tiempos.add(v));
    filters.shopify_colors.clear(); pending.shopify_colors.forEach(v => filters.shopify_colors.add(v));
  }

  function renderFacetPending(container, data, key, pending) {
    const entries = Object.entries(data || {});
    const searchableKeys = ["categories", "manufacturers", "shopify_colors"];
    const isSearchable = searchableKeys.includes(key);
    const LIMIT = 10;

    const facet = container.closest(".facet");
    if (!facet) return;

    let tools = facet.querySelector('.facet-tools[data-key="' + key + '"]');
    if (!tools && isSearchable) {
      tools = document.createElement("div");
      tools.className = "facet-tools";
      tools.dataset.key = key;
      tools.innerHTML = `
        <input
          type="text"
          class="facet-search"
          placeholder="Buscar..."
          data-key="${key}"
        />
      `;
      container.parentNode.insertBefore(tools, container);
    }

    let searchTerm = "";
    const searchInput = facet.querySelector('.facet-search[data-key="' + key + '"]');
    if (searchInput) searchTerm = searchInput.value.trim().toLowerCase();

    const filteredEntries = entries.filter(([name]) =>
      !isSearchable || String(name).toLowerCase().includes(searchTerm)
    );

    const expanded = container.dataset.expanded === "1";
    const visibleEntries = (isSearchable && !expanded)
      ? filteredEntries.slice(0, LIMIT)
      : filteredEntries;

    container.innerHTML = visibleEntries.map(([name, count]) => `
      <label class="facet-item">
        <input type="checkbox" value="${escapeHtml(name)}" ${pending[key].has(name) ? "checked" : ""}>
        <span class="facet-name">${
          key === "shopify_colors" && String(name).includes("__")
            ? escapeHtml(String(name).split("__")[1])
            : escapeHtml(name)
        }</span>
        <span class="facet-count">${count}</span>
      </label>
    `).join("");

    container.querySelectorAll("input[type='checkbox']").forEach(cb => {
      cb.addEventListener("change", () => {
        cb.checked ? pending[key].add(cb.value) : pending[key].delete(cb.value);
      });
    });

    let moreBtn = facet.querySelector('.facet-more[data-key="' + key + '"]');
    if (moreBtn) moreBtn.remove();

    if (isSearchable && filteredEntries.length > LIMIT) {
      moreBtn = document.createElement("button");
      moreBtn.type = "button";
      moreBtn.className = "facet-more";
      moreBtn.dataset.key = key;
      moreBtn.textContent = expanded ? "Ver menos" : `Ver más (${filteredEntries.length - LIMIT})`;

      container.parentNode.appendChild(moreBtn);

      moreBtn.addEventListener("click", () => {
        container.dataset.expanded = expanded ? "0" : "1";
        renderFacetPending(container, data, key, pending);
      });
    }

    if (searchInput && !searchInput.dataset.bound) {
      searchInput.dataset.bound = "1";
      searchInput.addEventListener("input", () => {
        container.dataset.expanded = "0";
        renderFacetPending(container, data, key, pending);
      });
    }
  }

  function renderFacet(container, data, key) {
    const entries = Object.entries(data || {});
    const searchableKeys = ["categories", "manufacturers", "shopify_colors"];
    const isSearchable = searchableKeys.includes(key);
    const LIMIT = 10;

    const facet = container.closest(".facet");
    if (!facet) return;

    let tools = facet.querySelector('.facet-tools[data-key="' + key + '"]');
    if (!tools && isSearchable) {
      tools = document.createElement("div");
      tools.className = "facet-tools";
      tools.dataset.key = key;
      tools.innerHTML = `
        <input
          type="text"
          class="facet-search"
          placeholder="Buscar..."
          data-key="${key}"
        />
      `;
      container.parentNode.insertBefore(tools, container);
    }

    let searchTerm = "";
    const searchInput = facet.querySelector('.facet-search[data-key="' + key + '"]');
    if (searchInput) searchTerm = searchInput.value.trim().toLowerCase();

    const filteredEntries = entries.filter(([name]) =>
      !isSearchable || String(name).toLowerCase().includes(searchTerm)
    );

    const expanded = container.dataset.expanded === "1";
    const visibleEntries = (isSearchable && !expanded)
      ? filteredEntries.slice(0, LIMIT)
      : filteredEntries;

    container.innerHTML = visibleEntries.map(([name, count]) => `
      <label class="facet-item">
        <input type="checkbox" value="${escapeHtml(name)}" ${filters[key].has(name) ? "checked" : ""}>
        <span class="facet-name">${
          key === "shopify_colors" && String(name).includes("__")
            ? escapeHtml(String(name).split("__")[1])
            : escapeHtml(name)
        }</span>
        <span class="facet-count">${count}</span>
      </label>
    `).join("");

    container.querySelectorAll("input[type='checkbox']").forEach(cb => {
      cb.addEventListener("change", () => {
        cb.checked ? filters[key].add(cb.value) : filters[key].delete(cb.value);
        resetAndSearch();
      });
    });

    let moreBtn = facet.querySelector('.facet-more[data-key="' + key + '"]');
    if (moreBtn) moreBtn.remove();

    if (isSearchable && filteredEntries.length > LIMIT) {
      moreBtn = document.createElement("button");
      moreBtn.type = "button";
      moreBtn.className = "facet-more";
      moreBtn.dataset.key = key;
      moreBtn.textContent = expanded ? "Ver menos" : `Ver más (${filteredEntries.length - LIMIT})`;

      container.parentNode.appendChild(moreBtn);

      moreBtn.addEventListener("click", () => {
        container.dataset.expanded = expanded ? "0" : "1";
        renderFacet(container, data, key);
      });
    }

    if (searchInput && !searchInput.dataset.bound) {
      searchInput.dataset.bound = "1";
      searchInput.addEventListener("input", () => {
        container.dataset.expanded = "0";
        renderFacet(container, data, key);
      });
    }

    const header = facet.querySelector(".facet-header");
    if (header && !header.dataset.bound) {
      header.dataset.bound = "1";
      header.addEventListener("click", () => {
        facet.classList.toggle("collapsed");
      });
    }
  }

  /* =========================
   * 3. WISHLIST BUSCADOR SOLO PC
   * ========================= */
  let searchWishlistData = { lists: [] };
  let searchWishlistAuth = false;
  let searchWishlistToastTimer = null;
  let currentWishlistTarget = null;
  let lastWishlistFocusedElement = null;

  function showSearchWishlistToast(message) {
    if (!searchWishlistToast) return;
    searchWishlistToast.textContent = message || "";
    searchWishlistToast.classList.add("is-visible");
    clearTimeout(searchWishlistToastTimer);
    searchWishlistToastTimer = setTimeout(() => {
      searchWishlistToast.classList.remove("is-visible");
    }, 3000);
  }

  function getSearchWishlistLists() {
    return Array.isArray(searchWishlistData && searchWishlistData.lists) ? searchWishlistData.lists : [];
  }

  function getSearchWishlistMembershipLists(variantId) {
    const lists = getSearchWishlistLists();
    return lists.filter(list => {
      return Array.isArray(list.items) && list.items.some(item => {
        return String(item.variantId) === String(variantId);
      });
    });
  }

  async function fetchSearchWishlistData() {
    const res = await fetch("/apps/wishlist/get", {
      method: "GET",
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    });

    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }

    if (res.status === 401) {
      searchWishlistAuth = false;
      searchWishlistData = { lists: [] };
      syncSearchWishlistButtons();
      return { ok: false, unauthenticated: true };
    }

    searchWishlistAuth = true;
    searchWishlistData = data && typeof data === "object" ? data : { lists: [] };

    if (!Array.isArray(searchWishlistData.lists)) {
      searchWishlistData.lists = [];
    }

    syncSearchWishlistButtons();
    return { ok: true, unauthenticated: false };
  }

  function syncSearchWishlistButtons() {
    if (isMobile()) return;

    modal.querySelectorAll(".search-wishlist-btn[data-variant-id]").forEach(btn => {
      const variantId = btn.dataset.variantId;
      const membershipLists = getSearchWishlistMembershipLists(variantId);
      btn.classList.toggle("is-active", membershipLists.length > 0);
    });
  }

  async function toggleSearchWishlist(action, productId, variantId, listName) {
    const res = await fetch("/apps/wishlist/toggle", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        action: action,
        productId: Number(productId),
        variantId: Number(variantId),
        listName: listName
      })
    });

    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }

    if (res.status === 401) {
      throw new Error("Tienes que iniciar sesión.");
    }

    if (!data.ok) {
      throw new Error(data.error || "No se pudo actualizar favoritos.");
    }

    await fetchSearchWishlistData();
    return data;
  }

  function closeSearchWishlistModal() {
    if (!searchWishlistModal) return;
    searchWishlistModal.hidden = true;
    document.documentElement.style.overflow = "";
    currentWishlistTarget = null;

    if (lastWishlistFocusedElement && typeof lastWishlistFocusedElement.focus === "function") {
      lastWishlistFocusedElement.focus();
    }
  }

  function openSearchWishlistModal() {
    if (!searchWishlistModal) return;
    lastWishlistFocusedElement = document.activeElement;
    searchWishlistModal.hidden = false;
    document.documentElement.style.overflow = "hidden";

    const firstOption = searchWishlistModal.querySelector(".search-wishlist-list-option");
    if (firstOption) firstOption.focus();
  }

  function renderSearchWishlistPicker(targetBtn) {
    if (!searchWishlistModalBody || !targetBtn) return;

    const lists = getSearchWishlistLists();
    const variantId = targetBtn.dataset.variantId || "";
    const membershipLists = getSearchWishlistMembershipLists(variantId);

    searchWishlistModalBody.innerHTML = "";

    if (searchWishlistModalSubtitle) {
      searchWishlistModalSubtitle.textContent = membershipLists.length
        ? "Pulsa una lista para añadirlo o quitarlo en esa lista."
        : "Selecciona la lista donde quieres guardar este producto.";
    }

    if (!lists.length) {
      const empty = document.createElement("div");
      empty.style.padding = "10px 0 2px";
      empty.style.fontSize = "13px";
      empty.style.color = "#6b7280";
      empty.textContent = "No hay listas disponibles.";
      searchWishlistModalBody.appendChild(empty);
      return;
    }

    lists.forEach(list => {
      const isInThisList = Array.isArray(list.items) && list.items.some(item => {
        return String(item.variantId) === String(variantId);
      });

      const option = document.createElement("button");
      option.type = "button";
      option.className = "search-wishlist-list-option" + (isInThisList ? " is-active" : "");
      option.setAttribute("data-list-name", list.name || "");
      option.setAttribute("aria-label", (isInThisList ? "Quitar de " : "Añadir a ") + (list.name || "lista"));

      option.innerHTML = `
        <span class="search-wishlist-list-option__left">
          <span class="search-wishlist-list-option__name">${escapeHtml(list.name || "Lista")}</span>
          <span class="search-wishlist-list-option__meta">${
            (typeof list.itemCount === "number" ? list.itemCount : (Array.isArray(list.items) ? list.items.length : 0)) === 1
              ? "1 producto guardado"
              : `${typeof list.itemCount === "number" ? list.itemCount : (Array.isArray(list.items) ? list.items.length : 0)} productos guardados`
          }</span>
        </span>
        <span class="search-wishlist-list-option__action">${isInThisList ? "Quitar" : "Añadir"}</span>
      `;

      option.addEventListener("click", async () => {
        const actionBadge = option.querySelector(".search-wishlist-list-option__action");
        try {
          option.disabled = true;
          if (actionBadge) actionBadge.textContent = "...";

          const toggleAction = isInThisList ? "remove" : "add";
          await toggleSearchWishlist(
            toggleAction,
            targetBtn.dataset.productId,
            targetBtn.dataset.variantId,
            list.name || "Favoritos"
          );

          showSearchWishlistToast(
            isInThisList
              ? `Producto borrado de "${list.name || "Lista"}".`
              : `Producto añadido a "${list.name || "Lista"}".`
          );

          closeSearchWishlistModal();
        } catch (err) {
          console.error(err);
          showSearchWishlistToast(err.message || "Error inesperado.");
          renderSearchWishlistPicker(targetBtn);
        }
      });

      searchWishlistModalBody.appendChild(option);
    });
  }

  searchWishlistModal?.addEventListener("click", e => {
    const closeTrigger = e.target.closest("[data-close-search-wishlist='true']");
    if (closeTrigger) {
      closeSearchWishlistModal();
    }
  });

  /* =========================
   * 4. FETCH SEARCH
   * ========================= */
  async function fetchResults(reset = false) {
    if (loading || finished) return;
    loading = true;

    const rate = getCurrentRate() || "3";

    const url =
      "https://buscador.inpexopcion.com/productsordina/search/?" +
      "q=" + encodeURIComponent(query) +
      "&page=" + page +
      "&rate_s=" + rate +
      "&sort_by=" + sortBy +
      "&sort_order=" + sortOrder +
      "&" + buildFilterParams();

    const res = await fetch(url);
    const data = await res.json();

    if (data.mode === "discovery") {
      totalEl.textContent = 0;
      setHasResults(0);
      resultsEl.innerHTML = "";
      toggleEmptyState(false);
      loading = false;
      return;
    }

    lastFacets = {
      categories_counts: data.categories_counts || {},
      manufacturers_counts: data.manufacturers_counts || {},
      tiempos_counts: data.tiempos_counts || {},
      shopify_colors_counts: data.shopify_colors_counts || {}
    };

    if (reset) {
      resultsEl.innerHTML = "";
      page = 1;
      finished = false;

      [catEl, manEl, timeEl, colorEl].forEach(el => {
        if (!el) return;
        el.dataset.expanded = "0";
      });

      renderFacet(catEl, data.categories_counts, "categories");
      renderFacet(manEl, data.manufacturers_counts, "manufacturers");
      renderFacet(timeEl, data.tiempos_counts, "tiempos");
      renderFacet(colorEl, data.shopify_colors_counts, "shopify_colors");

      resultsScroll.scrollTop = 0;
    }

    const totalFound = Number(data.total_products_found || 0);
    totalEl.textContent = totalFound;
    setHasResults(totalFound);
    toggleEmptyState(query.length > 0 && totalFound === 0);

    const items = data.response_data || [];
    if (!items.length) finished = true;

    resultsEl.insertAdjacentHTML(
      "beforeend",
      items.map(p => {
        const priceValue = parseFloat(p.pricewithtax_T1);
        const productUrl = p.shopify_handle ? "/products/" + p.shopify_handle : null;
        const isViewOnly = shouldShowViewInsteadOfAdd(p);

        const images = (p.shopify_images && p.shopify_images.length
          ? p.shopify_images
          : [p.image_url_1]).filter(Boolean);

        const firstImage = images[0] || FALLBACK_IMG;
        const showDesktopQty = shouldUseDesktopQtySelector();
        const canShowWishlist = !isMobile() && p.shopify_product_id && p.shopify_variant_id;

        const hasProductIds = !!p.part_number || !!(p.ean && p.ean !== "0");
        const showProductIds = shouldShowProductIdentifiers() && hasProductIds;

        return `
          <div class="card">
            ${
              canShowWishlist
                ? `
                <button
                  type="button"
                  class="search-wishlist-btn"
                  data-product-id="${escapeHtml(String(p.shopify_product_id || ""))}"
                  data-variant-id="${escapeHtml(String(p.shopify_variant_id || ""))}"
                  data-handle="${escapeHtml(p.shopify_handle || "")}"
                  aria-label="Guardar en favoritos"
                >
                  <span class="search-wishlist-btn__icon" aria-hidden="true">
                    <svg
                      class="icon-heart"
                      aria-hidden="true"
                      focusable="false"
                      role="presentation"
                      xmlns="http://www.w3.org/2000/svg"
                      width="44"
                      height="44"
                      viewBox="0 0 44 44"
                      fill="none"
                    >
                      <path
                        d="M22.0001 40.2087L4.03343 21.7067C2.45768 20.1611 1.41509 18.1539 1.05677 15.976C0.698461 13.7981 1.04305 11.5627 2.0406 9.59383V9.59383C2.80915 8.10196 3.9177 6.81168 5.27676 5.82714C6.63582 4.8426 8.20733 4.19138 9.86443 3.92605C11.5215 3.66072 13.2178 3.78872 14.8163 4.2997C16.4148 4.81068 17.8708 5.69034 19.0668 6.86767L22.0001 9.5425L24.9334 6.86767C26.1295 5.69071 27.5856 4.81138 29.184 4.30063C30.7825 3.78987 32.4786 3.66199 34.1356 3.92729C35.7925 4.1926 37.3639 4.84367 38.723 5.82797C40.0821 6.81228 41.1908 8.10225 41.9596 9.59383V9.59383C42.9566 11.5629 43.3008 13.7981 42.9425 15.9759C42.5843 18.1537 41.542 20.1608 39.9668 21.7067L22.0001 40.2087Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </span>
                </button>
                `
                : ""
            }

            ${productUrl ? `<a href="${productUrl}" style="text-decoration:none;color:inherit">` : ""}

              <div class="img" data-images='${escapeHtml(JSON.stringify(images))}'>
                <img
                  src="${firstImage}"
                  loading="lazy"
                  onerror="this.onerror=null;this.src='${FALLBACK_IMG}';"
                />
              </div>

              <div class="card-content">

                <div class="product-name">
                  ${escapeHtmlAllowEm(p.name)} ${productUrl ? "</a>" : ""}
                </div>

                ${
                  showProductIds
                    ? `
                      <div class="product-ids">
                        ${p.part_number ? `PN: ${escapeHtml(p.part_number)}` : ""}
                        ${p.part_number && (p.ean && p.ean !== "0") ? "<br>" : ""}
                        ${(p.ean && p.ean !== "0") ? `EAN: ${escapeHtml(p.ean)}` : ""}
                      </div>
                    `
                    : ""
                }

                <div class="card-meta">
                  ${priceValue > 0 ? `<div class="price">${priceValue.toFixed(2)} €</div>` : ""}

                  <div class="delivery-text">
                    ${formatPlazoBuscador(p, "card")}
                  </div>
                </div>

              </div>

              ${
                p.shopify_variant_id
                  ? (
                      isViewOnly
                        ? (
                            productUrl
                              ? `
                                <div class="add-row">
                                  <button
                                    type="button"
                                    class="add-to-cart"
                                    data-action="view"
                                    data-url="${escapeHtml(productUrl)}"
                                  >
                                    Ver
                                  </button>
                                </div>
                              `
                              : `
                                <div style="font-size:12px;color:#999">
                                  Disponible próximamente
                                </div>
                              `
                          )
                        : (
                            showDesktopQty
                              ? `
                                <div class="add-row">
                                  <div class="qty-box">
                                    <input
                                      type="number"
                                      class="qty-input"
                                      value="1"
                                      min="1"
                                      max="999"
                                      inputmode="numeric"
                                      aria-label="Cantidad"
                                    />
                                    <div class="qty-buttons">
                                      <button type="button" class="qty-btn qty-plus" aria-label="Sumar cantidad">+</button>
                                      <button type="button" class="qty-btn qty-minus" aria-label="Restar cantidad">−</button>
                                    </div>
                                  </div>
                                  <button
                                    type="button"
                                    class="add-to-cart"
                                    data-action="add"
                                    data-variant="${p.shopify_variant_id}"
                                  >
                                    ${getAddToCartLabel()}
                                  </button>
                                </div>
                              `
                              : `
                                <div class="add-row">
                                  <button
                                    type="button"
                                    class="add-to-cart"
                                    data-action="add"
                                    data-variant="${p.shopify_variant_id}"
                                  >
                                    ${getAddToCartLabel()}
                                  </button>
                                </div>
                              `
                          )
                    )
                  : `
                    <div style="font-size:12px;color:#999">
                      Disponible próximamente
                    </div>
                  `
              }
          </div>
        `;
      }).join("")
    );

    page++;
    loading = false;
    updateAddToCartButtonsText();

    if (!isMobile()) {
      fetchSearchWishlistData().catch(err => console.error(err));
    }
  }

  function resetAndSearch() {
    finished = false;
    page = 1;

    modal.classList.remove("show-recent");
    modal.style.display = "block";
    document.body.classList.add("search-open");
    positionModal();

    toggleEmptyState(false);
    showRecommendedProducts(false);
    fetchResults(true);
  }

  const clearBtn = modal.querySelector("#search-clear-btn");
  const desktopSearchCloseBtn = modal.querySelector("#desktop-search-close");

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      closeSearch();
    });
  }

  if (desktopSearchCloseBtn) {
    desktopSearchCloseBtn.addEventListener("click", () => {
      closeSearch();
    });
  }

  /* =========================
   * 5. ADD TO CART SHOPIFY
   * ========================= */
  async function addToCart(variantId, quantity, btn) {
    btn.classList.add("loading");
    btn.textContent = "Añadiendo...";

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity || 1
        })
      });

      if (!res.ok) throw new Error("Error al añadir");

      await refreshCartHeader();

      btn.textContent = "Añadido ✓";

      setTimeout(() => {
        const cartBtn =
          document.querySelector("[data-cart-toggle]") ||
          document.querySelector(".site-header-cart") ||
          document.querySelector('a[href="/cart"]');

        if (cartBtn) cartBtn.click();
      }, 300);

    } catch (e) {
      console.error(e);
      btn.textContent = "Error";
    } finally {
      setTimeout(() => {
        btn.textContent = getAddToCartLabel();
        btn.classList.remove("loading");
      }, 1500);
    }
  }

  async function refreshCartHeader() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;

      const cart = await res.json();

      document.querySelectorAll("[data-header-cart-count]").forEach(el => {
        el.textContent = "";
        el.setAttribute("data-header-cart-count", cart.item_count);
        el.classList.toggle("visible", cart.item_count > 0);
      });

      document.querySelectorAll("[data-cart-total]").forEach(el => {
        const euros = (cart.total_price / 100).toLocaleString("es-ES", {
          style: "currency",
          currency: "EUR"
        });
        el.textContent = `${euros} + iva`;
      });

    } catch (e) {
      console.error("Error actualizando header cart", e);
    }
  }

  recommendedProductsEl?.addEventListener("click", e => {
    const btn = e.target.closest(".recommended-add-to-cart");
    if (!btn) return;

    addToCart(btn.dataset.variant, 1, btn);
  });

  resultsEl.addEventListener("click", async e => {
    const minusBtn = e.target.closest(".qty-minus");
    if (minusBtn) {
      const row = minusBtn.closest(".add-row");
      const qtyInput = row ? row.querySelector(".qty-input") : null;
      if (!qtyInput) return;

      const current = Math.max(1, parseInt(qtyInput.value || "1", 10) || 1);
      qtyInput.value = String(Math.max(1, current - 1));
      return;
    }

    const plusBtn = e.target.closest(".qty-plus");
    if (plusBtn) {
      const row = plusBtn.closest(".add-row");
      const qtyInput = row ? row.querySelector(".qty-input") : null;
      if (!qtyInput) return;

      const current = Math.max(1, parseInt(qtyInput.value || "1", 10) || 1);
      qtyInput.value = String(Math.min(999, current + 1));
      return;
    }

    const wishlistBtn = e.target.closest(".search-wishlist-btn");
    if (wishlistBtn) {
      if (isMobile()) return;

      e.preventDefault();
      e.stopPropagation();

      const productId = wishlistBtn.dataset.productId;
      const variantId = wishlistBtn.dataset.variantId;

      if (!productId || !variantId) return;

      wishlistBtn.classList.add("is-loading");

      try {
        const result = await fetchSearchWishlistData();

        if (result.unauthenticated || !searchWishlistAuth) {
          showSearchWishlistToast("Tienes que iniciar sesión.");
          return;
        }

        const lists = getSearchWishlistLists();
        const membershipLists = getSearchWishlistMembershipLists(variantId);

        if (lists.length <= 1) {
          const targetListName = (lists[0] && lists[0].name) ? lists[0].name : "Favoritos";
          const inTargetList = membershipLists.some(list => String(list.name) === String(targetListName));

          await toggleSearchWishlist(
            inTargetList ? "remove" : "add",
            productId,
            variantId,
            targetListName
          );

          showSearchWishlistToast(inTargetList ? "Borrado de favoritos." : "Añadido a favoritos.");
          return;
        }

        currentWishlistTarget = wishlistBtn;
        renderSearchWishlistPicker(wishlistBtn);
        openSearchWishlistModal();

      } catch (err) {
        console.error(err);
        showSearchWishlistToast(err.message || "Error inesperado.");
      } finally {
        wishlistBtn.classList.remove("is-loading");
      }
      return;
    }

    const btn = e.target.closest(".add-to-cart");
    if (!btn) return;

    if (btn.dataset.action === "view") {
      const url = btn.dataset.url;
      if (url) {
        window.location.href = url;
      }
      return;
    }

    const card = btn.closest(".card");
    const qtyInput = card ? card.querySelector(".qty-input") : null;
    let quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;

    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;
    if (quantity > 999) quantity = 999;
    if (qtyInput) qtyInput.value = String(quantity);

    addToCart(btn.dataset.variant, quantity, btn);
  });

  resultsEl.addEventListener("input", e => {
    const qtyInput = e.target.closest(".qty-input");
    if (!qtyInput) return;

    let value = String(qtyInput.value || "").replace(/[^\d]/g, "");
    if (!value) {
      qtyInput.value = "1";
      return;
    }

    let num = parseInt(value, 10);
    if (!Number.isFinite(num) || num < 1) num = 1;
    if (num > 999) num = 999;

    qtyInput.value = String(num);
  });

  /* =========================
   * 6. UX INPUT
   * ========================= */
  let debounce;

  input.addEventListener("input", e => {
    if (isMobile()) return;

    query = e.target.value.trim();

    clearTimeout(debounce);
    clearTimeout(recentSearchSaveTimer);

    debounce = setTimeout(() => {
      if (query.length < 1) {
        openRecentSearchesBox();
        return;
      }

      if (query !== lastQuery) {
        clearAllFilters();
        lastQuery = query;
      }

      resetAndSearch();
    }, 300);

    if (query.length >= 2) {
      const termToSave = query;
      recentSearchSaveTimer = setTimeout(() => {
        saveRecentSearch(termToSave);
      }, 2500);
    }
  });

  const mobileInput = getMobileInput();

  if (mobileInput) {
    mobileInput.addEventListener("input", e => {
      query = e.target.value.trim();
      input.value = query;

      clearTimeout(debounce);
      clearTimeout(recentSearchSaveTimer);

      debounce = setTimeout(() => {
        if (query.length < 1) {
          openRecentSearchesBox();
          return;
        }

        if (query !== lastQuery) {
          clearAllFilters();
          lastQuery = query;
        }

        resetAndSearch();
      }, 300);

      if (query.length >= 2) {
        const termToSave = query;
        recentSearchSaveTimer = setTimeout(() => {
          saveRecentSearch(termToSave);
        }, 2500);
      }
    });

    mobileInput.addEventListener("keydown", e => {
      if (e.key === "Enter") {
        e.preventDefault();

        clearTimeout(debounce);
        query = mobileInput.value.trim();
        input.value = query;

        if (query.length < 1) {
          openRecentSearchesBox();
          return;
        }

        if (query !== lastQuery) {
          clearAllFilters();
          lastQuery = query;
        }

        resetAndSearch();
        mobileInput.blur();
      }
    });
  }

  if (isMobile()) {
    input.setAttribute("readonly", "readonly");
  }

  input.addEventListener("focus", () => {
    if (isMobile()) {
      openMobileSearchAndFocus();
      return;
    }

    if (!input.value.trim()) {
      openRecentSearchesBox();
    }
  });

  input.addEventListener("click", () => {
    if (isMobile()) {
      openMobileSearchAndFocus();
      return;
    }

    if (!input.value.trim()) {
      openRecentSearchesBox();
    }
  });

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      if (!searchWishlistModal.hidden) {
        closeSearchWishlistModal();
        return;
      }
      closeSearch();
    }
  });

  resultsScroll.addEventListener("scroll", () => {
    if (
      resultsScroll.scrollTop + resultsScroll.clientHeight >=
      resultsScroll.scrollHeight - 800
    ) {
      fetchResults();
    }
  });

  const sortSelectEl = modal.querySelector("#sort-select");
  const filtersDrawer = modal.querySelector("#filters-drawer");
  const mobileFilterBtn = modal.querySelector("#mobile-filter-btn");
  const sortDrawer = modal.querySelector("#sort-drawer");
  const mobileOrderBtn = modal.querySelector("#mobile-order-btn");
  const sortClose = modal.querySelector("#sort-close");
  const sortApply = modal.querySelector("#sort-apply");

  const SORT_MAP = {
    stock_desc: { by: "stock", order: "desc" },
    stock_asc: { by: "stock", order: "asc" },
    score_desc: { by: "score", order: "desc" },
    tiempo_entrega_asc: { by: "tiempo_entrega", order: "asc" },
    tiempo_entrega_desc: { by: "tiempo_entrega", order: "desc" },
    pricewithtax_asc: { by: "pricewithtax", order: "asc" },
    pricewithtax_desc: { by: "pricewithtax", order: "desc" }
  };

  function openSortDrawer() {
    if (!isMobile()) return;

    const currentKey =
      Object.keys(SORT_MAP).find(k => SORT_MAP[k].by === sortBy && SORT_MAP[k].order === sortOrder) ||
      "stock_desc";

    sortDrawer.querySelectorAll('input[name="sort-option"]').forEach(r => {
      r.checked = (r.value === currentKey);
    });

    sortDrawer.classList.add("open");
  }

  function closeSortDrawer() {
    sortDrawer.classList.remove("open");
  }

  if (mobileOrderBtn) mobileOrderBtn.addEventListener("click", openSortDrawer);
  if (sortClose) sortClose.addEventListener("click", closeSortDrawer);

  if (sortApply) {
    sortApply.addEventListener("click", () => {
      const checked = sortDrawer.querySelector('input[name="sort-option"]:checked');
      const key = checked ? checked.value : "stock_desc";

      const cfg = SORT_MAP[key] || SORT_MAP.stock_desc;
      sortBy = cfg.by;
      sortOrder = cfg.order;

      if (sortSelectEl) sortSelectEl.value = key;

      closeSortDrawer();
      resetAndSearch();
    });
  }

  function syncSortSelectFromState() {
    if (!sortSelectEl) return;

    const key = Object.keys(SORT_MAP).find(k =>
      SORT_MAP[k].by === sortBy && SORT_MAP[k].order === sortOrder
    ) || "stock_desc";

    sortSelectEl.value = key;
  }

  if (sortSelectEl) {
    syncSortSelectFromState();

    sortSelectEl.addEventListener("change", () => {
      const cfg = SORT_MAP[sortSelectEl.value] || SORT_MAP.stock_desc;
      sortBy = cfg.by;
      sortOrder = cfg.order;
      resetAndSearch();
    });
  }

  const dfCat = modal.querySelector("#df-categories");
  const dfMan = modal.querySelector("#df-manufacturers");
  const dfTime = modal.querySelector("#df-tiempos");
  const dfColor = modal.querySelector("#df-shopify-colors");

  const filtersClose = modal.querySelector("#filters-close");
  const filtersApply = modal.querySelector("#filters-apply");
  const filtersClear = modal.querySelector("#filters-clear");

  let pendingFilters = null;

  function openFiltersDrawer() {
    if (!isMobile()) return;
    pendingFilters = cloneCurrentFilters();

    [dfCat, dfMan, dfTime, dfColor].forEach(el => { if (el) el.dataset.expanded = "0"; });

    renderFacetPending(dfCat, lastFacets.categories_counts, "categories", pendingFilters);
    renderFacetPending(dfMan, lastFacets.manufacturers_counts, "manufacturers", pendingFilters);
    renderFacetPending(dfTime, lastFacets.tiempos_counts, "tiempos", pendingFilters);
    renderFacetPending(dfColor, lastFacets.shopify_colors_counts, "shopify_colors", pendingFilters);
    filtersDrawer.classList.add("open");
  }

  function closeFiltersDrawer() {
    filtersDrawer.classList.remove("open");
    pendingFilters = null;
  }

  if (mobileFilterBtn) mobileFilterBtn.addEventListener("click", openFiltersDrawer);
  if (filtersClose) filtersClose.addEventListener("click", closeFiltersDrawer);

  if (filtersClear) {
    filtersClear.addEventListener("click", () => {
      if (!pendingFilters) return;
      pendingFilters.categories.clear();
      pendingFilters.manufacturers.clear();
      pendingFilters.tiempos.clear();
      pendingFilters.shopify_colors.clear();

      renderFacetPending(dfCat, lastFacets.categories_counts, "categories", pendingFilters);
      renderFacetPending(dfMan, lastFacets.manufacturers_counts, "manufacturers", pendingFilters);
      renderFacetPending(dfTime, lastFacets.tiempos_counts, "tiempos", pendingFilters);
      renderFacetPending(dfColor, lastFacets.shopify_colors_counts, "shopify_colors", pendingFilters);
    });
  }

  if (filtersApply) {
    filtersApply.addEventListener("click", () => {
      if (!pendingFilters) return;
      applyPendingFilters(pendingFilters);
      closeFiltersDrawer();
      resetAndSearch();
    });
  }

  modal.addEventListener("click", e => {
    const chip = e.target.closest(".recent-search-chip-term");
    if (chip) {
      const term = chip.dataset.term || "";
      const mi = getMobileInput();

      input.value = term;
      query = term;
      if (mi) mi.value = term;

      closeRecentSearchesBox();

      if (query !== lastQuery) {
        clearAllFilters();
        lastQuery = query;
      }

      resetAndSearch();
      return;
    }

    const removeBtn = e.target.closest(".recent-search-chip-remove");
    if (removeBtn) {
      removeRecentSearch(removeBtn.dataset.removeTerm || "");
      renderRecentSearches();
      return;
    }

    const clearBtnRecent = e.target.closest("#desktop-recent-clear");
    if (clearBtnRecent) {
      clearRecentSearches();
      renderRecentSearches();
    }
  });

  let _blockNextSearchClick = false;

  function findSearchActivator(el) {
    const a = el.closest("a,button,[role='button']");
    if (!a) return null;

    const label = (a.getAttribute("aria-label") || "").toLowerCase();
    const href  = (a.getAttribute("href") || "").toLowerCase();
    const cls   = (a.className || "").toLowerCase();
    const id    = (a.id || "").toLowerCase();

    if (label.includes("carrito") || label.includes("cart") || cls.includes("cart")) return null;
    if (label.includes("menú") || label.includes("menu")) return null;

    if (href.includes("/search")) return a;
    if (label.includes("buscar") || label.includes("search")) return a;
    if (cls.includes("search") || id.includes("search")) return a;

    return null;
  }

  function onSearchTouchEnd(e) {
    if (!isMobile()) return;
    if (modal.contains(e.target)) return;

    const act = findSearchActivator(e.target);
    if (!act) return;

    _blockNextSearchClick = true;

    e.preventDefault();
    e.stopPropagation();

    openMobileSearchAndFocus();
  }

  function onSearchClickCapture(e) {
    if (!isMobile()) return;
    if (!_blockNextSearchClick) return;

    const act = findSearchActivator(e.target);
    if (!act) return;

    _blockNextSearchClick = false;
    e.preventDefault();
    e.stopPropagation();
  }

  document.addEventListener("touchend", onSearchTouchEnd, { capture: true, passive: false });
  document.addEventListener("click", onSearchClickCapture, true);
});